<template>
  <section class="Main0001" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row :gutter="0" class="TabRowHead">
      <el-col :span="6" style="background: white">
        <el-badge class="item NotificationBell" >
          <div @click="goToUserNoticeScreen" v-if="showNotification">
            <img src="../../../assets/sp_image/bullhorn-solid.svg" alt="">
            <span class="NotificationTik"></span>
          </div>
        </el-badge>
      </el-col>
      <el-col :span="12">
        <img src="../../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6">
        <el-radio-group v-model="direction" class="RadioGroup"></el-radio-group>
        <div @click="drawer = true" class="MenuOptions">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <el-drawer :visible.sync="drawer" :direction="direction" class="MenuDrawer">
          <el-row class="tac">
            <el-col class="ListOfOptions">
              <el-menu
                default-active="1"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
              >
                <el-submenu index="1" >
                  <template slot="title">
                    <span>テーマ</span>
                  </template>
                  <el-menu-item-group v-if="display_today_article_link_flag">
                    <el-menu-item @click="todayArticleLoading">
                      {{getTodayArticleLabel}}
                    </el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item v-for="(item) in getthemetopics"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                      :index="item.index"
                      @click="handleTopicsValue(item.value, item.id, item.label, item.news_article_count, item.web_article_count, item.sc_search_condition_defined_flag, item.web_news_search_condition_defined_flag,item.magazine_article_count,item.magazine_search_condition_defined_flag)"
                      >{{item.value}}</el-menu-item>
                  </el-menu-item-group>
                  <el-submenu v-for="item in getthemegrouptopics"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                      :index="item.index"
                      >
                    <template slot="title">
                      <span @click="handleThemeGroupValue(item.value, item.id, item.label, item.news_article_count, item.web_article_count, item.sc_search_condition_defined_flag, item.web_news_search_condition_defined_flag,item.magazine_article_count,item.magazine_search_condition_defined_flag)">{{item.label}}</span>
                    </template>
                    <el-menu-item v-for="childItem in item.children"
                      :key="childItem.id"
                      :label="childItem.label"
                      :value="childItem.value"
                      :index="childItem.index"
                      @click="handleThemeValue(childItem.value, childItem.id, childItem.label, childItem.news_article_count, childItem.web_article_count, childItem.sc_search_condition_defined_flag, childItem.web_news_search_condition_defined_flag,childItem.magazine_article_count,childItem.magazine_search_condition_defined_flag)"
                      >{{childItem.value}}</el-menu-item>
                  </el-submenu>
                  <el-menu-item-group>
                    <el-menu-item v-for="(item) in gettheme"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                      :index="item.index"
                      @click="handleThemeValue(item.value, item.id, item.label, item.news_article_count, item.web_article_count, item.sc_search_condition_defined_flag, item.web_news_search_condition_defined_flag,item.magazine_article_count,item.magazine_search_condition_defined_flag)"
                    >{{item.value}}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>

              <el-menu
                default-active="1"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"

              >
                <el-menu-item @click="goToSearchScreen">
                  <template slot="title">
                    <span>
                      記事検索
                    </span>
                  </template>
                </el-menu-item>
                <el-menu-item index="1-3-4" @click="GotoThemeMailScreen"  v-if="sendMailValue == 0 && display_theme_mail_link_flag == 1">
                  このテーマのメールで送信 
                </el-menu-item>
              </el-menu>


              <el-menu
                default-active="2"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
              >
                <el-submenu index="1">
                  <template slot="title">
                    <span>その他</span>
                  </template>
                  <el-menu-item-group>
                    <router-link :to="{ name: 'sp_0011'}">
                      <el-menu-item index="1-1">検索条件登録</el-menu-item>
                    </router-link>
                    <router-link :to="{ name: 'sp_0014'}">
                      <el-menu-item index="1-2" v-if="pdf_usage_display_flag">原文利用実績</el-menu-item>
                    </router-link>
                    <!-- <el-menu-item index="1-3" v-if="external_link_flag">
                      <a :href=externalDbUrl target="_blank">
                        データベース
                      </a>
                    </el-menu-item> -->
                    <el-menu-item index="1-4" @click="logoutfunction">ログアウト</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
        </el-drawer>
      </el-col>
      <el-row class="CompanyRelated">
        <el-row class="Toast__Row">
          <el-col class="Toast__Message" v-show="isNoticeExist">{{adminNotice}}</el-col>
        </el-row>
        <el-row class="">
          <el-col   class="">
             <span class="Company__related__title">{{selected_theme_name}}</span>
             <!-- 2025/12/23 生成AIサービス連携 START -->
             <span class="" v-if="ai_link_flag">
               <el-link type="primary" @click="handleAiButtonClick" :underline="false" class="ai-link">生成AIサービスへ</el-link>
             </span>
             <!-- 2025/12/23 生成AIサービス連携 END -->
          </el-col>
        </el-row>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <div class="DatePickerBlock">
              <i class="el-icon-date DatePickerIcon"></i>
              <v-date-picker mode="range" v-model="range" locale="ja" class="SelectDateRange" :inputProps="{readOnly:true}" :attributes="attributes" :min-date="new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1)" :max-date="new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)" @input="selectDateForSearch"/>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button round type="info" plain class="LatestDate" @click="loadLatestDateArticle">最新日</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-row>
    <el-row :gutter="0" class="TabRow">
      <template>
        <el-tabs type="card" @tab-click="handleClick" v-model="AllTabs">
          <!--            ================***************** Tab 1 *****************======================             -->
          <el-tab-pane label="全媒体" name="first" id="All__tab" v-if="this.tabs.length>=2">
            <el-collapse v-model="activeTab" accordion>
              <!--            ================***************** accordion 1 *****************======================             -->
              <div class="AccordionCustom" v-if="news_article_flag&&getUserGroup_News_Article_Flag">
                <el-row class="ArticleAction">
                  <el-col>
                    <div class="CheckAllArticle">
                      <el-checkbox v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
                      <!-- <br /> -->
                      <span>全選択</span>
                    </div>
                  </el-col>
                  <el-col>
                    <div class="FileBatchMobile" @click="sendtopdfdisplay">
                      <span>一括表示</span>
                    </div>
                  </el-col>
                  <el-col>
                    <!-- <router-link to="/sp/0002_1"> -->
                      <div class="SortMobile" @click="sentToNewsSortScreen">
                        <span>ソート</span>
                      </div>
                    <!-- </router-link> -->
                  </el-col>
                </el-row>
                <el-collapse-item :title=newsCount name="1" class="NewsTab__Collapse">
                  <el-checkbox-group
                    v-model="checkedNewsArticle"
                    @change="handleCheckedNewsArticleChange"
                    class="NoneCheck"
                    tabindex="0"
                  >
                    <el-checkbox
                      v-for="m_article in getMobNewsArticles"
                      :label="m_article.article_no"
                      :key="m_article.article_no"
                      v-infinite-scroll="load" infinite-scroll-disabled="enabled"
                    >
                      <el-row :gutter="0">
                        <el-col :span="22" class="ArticleHeader">
                          {{m_article.article_title}}
                          <el-row class="ThirdCompanyInfo">
                            <el-col :span="4">
                              <div v-if="m_article.data_section == 1">
                                <img src="../../../assets/sp_image/header_logoArticle.png" alt="CompanyLogo" width="60" />
                              </div>
                              <div v-else-if="m_article.data_section == 2">
                                <img src="../../../assets/image/Nikkie-logo-web.svg" alt="NikkieLogo" width="60" />
                              </div>
                            </el-col>
                            <el-col :span="20" class="NewsPaperDetail">
                              <div>{{m_article.media_name}}</div>
                              <div>{{m_article.issue_date}}</div>
                              <div>{{m_article.issue_type}}</div>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="2" class="Icon__Block" v-if="m_article.data_section == 1">
                          <div v-if="mc_pdf_view_flag == false || m_article.no_image_flag == true" class="PdfFormat_Disable"></div>
                          <div @click="sendToErrorDisplay(m_article)" v-else class="PdfFormat"></div>
                          <div class="TextFormat_Disable" v-if="mc_text_view_flag == false || m_article.no_text_flag == true"></div>
                          <div @click="getPdfPrintScreen(m_article)" v-else class="TextFormat"></div>
                        </el-col>
                        <el-col :span="2" class="Icon__Block" v-else-if="m_article.data_section == 2">
                          <div v-if="sc_pdf_view_flag == false || m_article.no_image_flag == true" class="PdfFormat_Disable"></div>
                          <div @click="sendToErrorDisplay(m_article)" v-else class="PdfFormat"></div>
                          <div class="TextFormat_Disable" v-if="sc_text_view_flag == false || m_article.no_text_flag == true"></div>
                          <div @click="getPdfPrintScreen(m_article)" v-else class="TextFormat"></div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col class="ariticle-bottom" v-if="m_article.article_comment != '' && m_article.article_comment != null ">
                          <ul>
                            <li>
                              <div class="message ico_comment_upSmall AllNewsico_comment_upSmall"></div>
                            </li>
                            <li>              
                              <div class="User__comment" v-html="m_article.article_comment"></div>
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </el-checkbox>
                  </el-checkbox-group>
                    <!-- 2020/11/26  BT08460_EXTERNAL-1812  START -->
                    <!-- <p v-if="this.getIsTopPageInitialLoading || loading" class="centeralign_css_p">表示中...( {{ this.getMobNewsArticles.length + 1 }}件 ～ {{ this.getMobNewsArticles.length + 10 }}件 )</p>  -->
                    <p v-if="(this.getIsTopPageInitialLoading || loading) && showbar" class="centeralign_css_p">表示中...( {{ this.getMobNewsArticles.length + 1 }}件 ～ {{ this.getMobNewsArticles.length + 10 }}件 )</p>
                    <!-- <p v-if="this.getIsTopPageInitialLoading == false && (IsNoMore)" class="centeralign_css_p">レコードがありません</p>  -->
                    <p v-if="this.getIsTopPageInitialLoading == false && (IsNoMore)" class="centeralign_css_p">レコードの最後です</p> 
                    <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  -->
                    <p v-if="this.getIsTopPageInitialLoading == false && (NoDefaultNewsData)" class="centeralign_css_p">ヒット結果は0件です</p> 
                  </el-collapse-item>
              </div>

              <!--            ================***************** magazine *****************======================             -->
              <div class="AccordionCustom" v-if="getMagazine_Article_Flag&&getUserGroup_Magazine_Article_Flag">
                <el-row class="ArticleAction">
                  <el-col>
                    <!-- <router-link to="/sp/0002_1"> -->
                    <div class="SortMobile" @click="sentToMagazineSortScreen">
                      <span>ソート</span>
                    </div>
                    <!-- </router-link> -->
                  </el-col>
                </el-row>
                <el-collapse-item :title=magazineCount name="5" class="Magazine__Collapse">
                  <el-checkbox-group
                      v-model="checkedMagazineArticle"
                      @change="handleCheckedMagazineArticleChange"
                      class="NoneCheck"
                      tabindex="0"
                  >
                    <el-checkbox
                        v-for="m_Magazine__article in getMagazineArticledetails"
                        :label="m_Magazine__article.article_no"
                        :key="m_Magazine__article.article_no"
                        v-infinite-scroll="magazineLoad" infinite-scroll-disabled="enabled"
                    >
                      <el-row :gutter="0">
                        <el-col :span="24" class="ArticleHeader WebArticle">
                          <el-link type="primary" v-if="m_Magazine__article.sales_datetime_flag" @click="$gotoEpub(m_Magazine__article.contentsId,m_Magazine__article.start_page,m_Magazine__article.sales_to_datetime)">{{m_Magazine__article.title}}</el-link>
                          <el-link type="primary" style="color:black" v-else>{{m_Magazine__article.title}}</el-link>
                          <el-row>
                            <el-col :span="24" class="WebNewsPaperDetail">
                              <div class="InnerDetail">
                                <div>{{m_Magazine__article.magazine_name}}</div>
                                <div>{{m_Magazine__article.cover_date}}</div>
                              </div>
                              <div>
                              </div>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col class="ariticle-bottom" v-if="m_Magazine__article.comment != '' && m_Magazine__article.comment != null ">
                          <ul>
                            <li>
                              <div class="message ico_comment_upSmall AllNewsico_comment_upSmall"></div>
                            </li>
                            <li>
                              <!-- 2022/08/01  #13357  START -->
                              <!-- <div class="User__comment">{{m_Magazine__article.comment}}</div> -->
                              <div class="User__comment" v-html="m_Magazine__article.comment"></div>
                              <!-- 2022/08/01  #13357  END -->
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  START -->
                  <!-- <p v-if="this.getIsTopPageInitialLoading || webLoading" class="centeralign_css_p">表示中...( {{ this.getWebArticledetails.length + 1 }}件 ～ {{ this.getWebArticledetails.length + 10 }}件 )</p> -->
                  <p v-if="(this.getIsTopPageInitialLoading || magazineLoading) && showMagazinebar" class="centeralign_css_p">表示中...( {{ this.getMagazineArticledetails.length + 1 }}件 ～ {{ this.getMagazineArticledetails.length + 10 }}件 )</p>
                  <!-- <p v-if="this.getIsTopPageInitialLoading == false && (IsWebNoMore)" class="centeralign_css_p">レコードがありません</p>  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (IsMagazineNoMore)" class="centeralign_css_p">レコードの最後です</p>
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (NoDefaultMagazineData)" class="centeralign_css_p">ヒット結果は0件です</p>
                </el-collapse-item>
              </div>


              <!--            ================***************** accordion 2 *****************======================             -->
              <div class="AccordionCustom" v-if="web_news_article_flag&&user_group_web_news_article_flag">
                <el-row class="ArticleAction">
                  <el-col>
                    <!-- <router-link to="/sp/0002_1"> -->
                    <div class="SortMobile" @click="sentToWebSortScreen">
                      <span>ソート</span>
                    </div>
                    <!-- </router-link> -->
                  </el-col>
                </el-row>
                <el-collapse-item :title=webCount name="2" class="Web__Collapse">
                  <el-checkbox-group
                    v-model="checkedWebArticle"
                    @change="handleCheckedWebArticleChange"
                    class="NoneCheck"
                    tabindex="0"
                  >
                    <el-checkbox
                      v-for="m_Web__article in getWebArticledetails"
                      :label="m_Web__article.article_no"
                      :key="m_Web__article.article_no"
                      v-infinite-scroll="webLoad" infinite-scroll-disabled="enabled"
                    >
                      <el-row :gutter="0">
                        <el-col :span="24" class="ArticleHeader WebArticle">
                          <el-link type="primary" v-if="m_Web__article.webUrl != '' && m_Web__article.webUrl != null" :href=m_Web__article.webUrl target="_blank">{{m_Web__article.title}}</el-link>
                          <el-link type="primary" v-else>{{m_Web__article.title}}</el-link>
                          <el-row>
                            <el-col :span="24" class="WebNewsPaperDetail">
                              <div class="InnerDetail">
                                <div>{{m_Web__article.media_name}}</div>
                                <div>{{m_Web__article.reporting_date}}</div>
                              </div>
                              <!-- 2021/02/05 #10496 START -->
                              <!-- <div>
                                <img src="../../../assets/sp_image/New__Tab__Icon.png" alt="">
                              </div> -->
                              <!-- 2021/02/05 #10496 END -->
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col class="ariticle-bottom" v-if="m_Web__article.comment != '' && m_Web__article.comment != null ">
                          <ul>
                            <li>
                              <div class="message ico_comment_upSmall AllNewsico_comment_upSmall"></div>
                            </li>
                            <li>
                              <!-- 2022/08/01  #13357  START -->
                              <!-- <div
                                class="User__comment">{{m_Web__article.comment}}
                              </div> -->
                              <div class="User__comment" v-html="m_Web__article.comment"></div>
                              <!-- 2022/08/01  #13357  END -->
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  START -->
                  <!-- <p v-if="this.getIsTopPageInitialLoading || webLoading" class="centeralign_css_p">表示中...( {{ this.getWebArticledetails.length + 1 }}件 ～ {{ this.getWebArticledetails.length + 10 }}件 )</p> -->
                  <p v-if="(this.getIsTopPageInitialLoading || webLoading) && showWebbar" class="centeralign_css_p">表示中...( {{ this.getWebArticledetails.length + 1 }}件 ～ {{ this.getWebArticledetails.length + 10 }}件 )</p>
                  <!-- <p v-if="this.getIsTopPageInitialLoading == false && (IsWebNoMore)" class="centeralign_css_p">レコードがありません</p>  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (IsWebNoMore)" class="centeralign_css_p">レコードの最後です</p> 
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  --> 
                  <p v-if="this.getIsTopPageInitialLoading == false && (NoDefaultData)" class="centeralign_css_p">ヒット結果は0件です</p> 
                </el-collapse-item>
              </div>
            </el-collapse>
          </el-tab-pane>

          <!--            ================***************** Tab 2 *****************======================             -->

          <el-tab-pane :label=getTotalNewsLabel name="second" v-if="news_article_flag && user_group_news_article_flag">
            <el-collapse v-model="activeTab2" accordion>

              <div class="AccordionCustom">
                <el-row class="ArticleAction">
                  <el-col>
                    <div class="CheckAllArticle">
                      <el-checkbox v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
                      <!-- <br /> -->
                      <span>全選択</span>
                    </div>
                  </el-col>
                  <el-col>
                    <div class="FileBatchMobile" @click="sendtopdfdisplay">
                      <span>一括表示</span>
                    </div>
                  </el-col>
                  <el-col>
                    <!-- <router-link to="/sp/0002_1"> -->
                      <div class="SortMobile" @click="sentToNewsSortScreen">
                        <span>ソート</span>
                      </div>
                    <!-- </router-link> -->
                  </el-col>
                </el-row>
                <el-collapse-item :title=newsCount name="1" class="NewsTab__Collapse">
                  <el-checkbox-group
                    v-model="checkedNewsArticle"
                    @change="handleCheckedNewsArticleChange"
                    class="NoneCheck"
                    tabindex="0"
                  >
                    <el-checkbox
                      v-for="m_article in getMobNewsArticles"
                      :label="m_article.article_no"
                      :key="m_article.article_no"
                      v-infinite-scroll="load" infinite-scroll-disabled="enabled"
                    >
                      <el-row :gutter="0">
                        <el-col :span="22" class="ArticleHeader">
                          {{m_article.article_title}}
                          <el-row class="ThirdCompanyInfo">
                            <el-col :span="4">
                              <div v-if="m_article.data_section == 1">
                                <img src="../../../assets/sp_image/header_logoArticle.png" alt="CompanyLogo" width="60" />
                              </div>
                              <div v-else-if="m_article.data_section == 2">
                                <img src="../../../assets/image/Nikkie-logo-web.svg" alt="NikkieLogo" width="60" />
                              </div>
                            </el-col>
                            <el-col :span="20" class="NewsPaperDetail">
                              <div>{{m_article.media_name}}</div>
                              <div>{{m_article.issue_date}}</div>
                              <div>{{m_article.issue_type}}</div>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="2" class="Icon__Block" v-if="m_article.data_section == 1">
                          <div class="PdfFormat_Disable" v-if="mc_pdf_view_flag == false || m_article.no_image_flag == true"></div>
                          <div @click="sendToErrorDisplay(m_article)" v-else class="PdfFormat"></div>
                          <div class="TextFormat_Disable" v-if="mc_text_view_flag == false || m_article.no_text_flag == true"></div>
                          <div @click="getPdfPrintScreen(m_article)" v-else class="TextFormat"></div>
                        </el-col>
                        <el-col :span="2" class="Icon__Block" v-else-if="m_article.data_section == 2">
                          <div class="PdfFormat_Disable" v-if="sc_pdf_view_flag == false || m_article.no_image_flag == true"></div>
                          <div @click="sendToErrorDisplay(m_article)" v-else class="PdfFormat"></div>
                          <div class="TextFormat_Disable" v-if="sc_text_view_flag == false || m_article.no_text_flag == true"></div>
                          <div @click="getPdfPrintScreen(m_article)" v-else class="TextFormat"></div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col class="ariticle-bottom" v-if="m_article.article_comment != '' && m_article.article_comment != null ">
                          <ul>
                            <li>
                              <div class="message ico_comment_upSmall AllNewsico_comment_upSmall"></div>
                            </li>
                            <li>              
                              <div
                                class="User__comment" v-html="m_article.article_comment">
                              </div>
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  START -->
                  <!-- <p v-if="this.getIsTopPageInitialLoading || loading" class="centeralign_css_p">表示中...( {{ this.getMobNewsArticles.length + 1 }}件 ～ {{ this.getMobNewsArticles.length + 10 }}件 )</p> -->
                  <p v-if="(this.getIsTopPageInitialLoading || loading) && showbar" class="centeralign_css_p">表示中...( {{ this.getMobNewsArticles.length + 1 }}件 ～ {{ this.getMobNewsArticles.length + 10 }}件 )</p>
                  <!-- <p v-if="this.getIsTopPageInitialLoading == false && (IsNoMore)" class="centeralign_css_p">レコードがありません</p>  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (IsNoMore)" class="centeralign_css_p">レコードの最後です</p> 
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (NoDefaultNewsData)" class="centeralign_css_p">ヒット結果は0件です</p> 
                </el-collapse-item>
              </div>
            </el-collapse>
          </el-tab-pane>
          <!--            ================***************** Tab Magazine *****************======================             -->

          <el-tab-pane :label=getMagazineTotalLabel name="fourth" v-if="getMagazine_Article_Flag && getUserGroup_Magazine_Article_Flag">
            <el-collapse v-model="activeTab3" accordion>

              <div class="AccordionCustom">
                <el-row class="ArticleAction">
                  <el-col>
                    <!-- <router-link to="/sp/0002_1"> -->
                    <div class="SortMobile" @click="sentToMagazineSortScreen">
                      <span>ソート</span>
                    </div>
                    <!-- </router-link> -->
                  </el-col>
                </el-row>
                <el-collapse-item :title=magazineCount name="1" class="Magazine__Collapse">
                  <el-checkbox-group
                      v-model="checkedMagazineArticle"
                      @change="handleCheckedMagazineArticleChange"
                      class="NoneCheck"
                      tabindex="0"
                  >
                    <el-checkbox
                        v-for="m_Magazine__article in getMagazineArticledetails"
                        :label="m_Magazine__article.article_no"
                        :key="m_Magazine__article.article_no"
                        v-infinite-scroll="magazineLoad" infinite-scroll-disabled="enabled"
                    >
                      <el-row :gutter="0">
                        <el-col :span="24" class="ArticleHeader WebArticle">
                          <el-link type="primary" v-if="m_Magazine__article.sales_datetime_flag" @click="$gotoEpub(m_Magazine__article.contentsId,m_Magazine__article.start_page,m_Magazine__article.sales_to_datetime)">{{m_Magazine__article.title}}</el-link>
                          <el-link type="primary" style="color:black" v-else>{{m_Magazine__article.title}}</el-link>
                          <el-row>
                            <el-col :span="24" class="WebNewsPaperDetail">
                              <div class="InnerDetail">
                                <div>{{m_Magazine__article.magazine_name}}</div>
                                <div>{{m_Magazine__article.cover_date}}</div>
                              </div>
                              <div>
                              </div>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col class="ariticle-bottom" v-if="m_Magazine__article.comment != '' && m_Magazine__article.comment != null ">
                          <ul>
                            <li>
                              <div class="message ico_comment_upSmall AllNewsico_comment_upSmall"></div>
                            </li>
                            <li>
                              <!-- 2022/08/01  #13357  START -->
                              <!-- <div class="User__comment">{{m_Magazine__article.comment}}</div> -->
                              <div class="User__comment" v-html="m_Magazine__article.comment"></div>
                              <!-- 2022/08/01  #13357  END -->
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  START -->
                  <!-- <p v-if="this.getIsTopPageInitialLoading || webLoading" class="centeralign_css_p">表示中...( {{ this.getWebArticledetails.length + 1 }}件 ～ {{ this.getWebArticledetails.length + 10 }}件 )</p> -->
                  <p v-if="(this.getIsTopPageInitialLoading || magazineLoading) && showMagazinebar" class="centeralign_css_p">表示中...( {{ this.getMagazineArticledetails.length + 1 }}件 ～ {{ this.getMagazineArticledetails.length + 10 }}件 )</p>
                  <!-- <p v-if="this.getIsTopPageInitialLoading == false && (IsWebNoMore)" class="centeralign_css_p">レコードがありません</p>  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (IsMagazineNoMore)" class="centeralign_css_p">レコードの最後です</p>
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (NoDefaultMagazineData)" class="centeralign_css_p">ヒット結果は0件です</p>
                </el-collapse-item>
              </div>
            </el-collapse>
          </el-tab-pane>

          <!--            ================***************** Tab 3 *****************======================             -->

          <el-tab-pane :label=getWebTotalLabel name="third" v-if="web_news_article_flag && user_group_web_news_article_flag">
            <el-collapse v-model="activeTab3" accordion>

              <div class="AccordionCustom">
                <el-row class="ArticleAction">
                  <el-col>
                    <!-- <router-link to="/sp/0002_1"> -->
                    <div class="SortMobile" @click="sentToWebSortScreen">
                      <span>ソート</span>
                    </div>
                    <!-- </router-link> -->
                  </el-col>
                </el-row>
                <el-collapse-item :title=webCount name="1" class="Web__Collapse">
                  <el-checkbox-group
                    v-model="checkedWebArticle"
                    @change="handleCheckedWebArticleChange"
                    class="NoneCheck"
                    tabindex="0"
                  >
                    <el-checkbox
                      v-for="m_Web__article in getWebArticledetails"
                      :label="m_Web__article.article_no"
                      :key="m_Web__article.article_no"
                      v-infinite-scroll="webLoad" infinite-scroll-disabled="enabled"
                    >
                      <el-row :gutter="0">
                        <el-col :span="24" class="ArticleHeader WebArticle">
                          <el-link type="primary" v-if="m_Web__article.webUrl != '' && m_Web__article.webUrl != null" :href=m_Web__article.webUrl target="_blank">{{m_Web__article.title}}</el-link>
                          <el-link type="primary" v-else>{{m_Web__article.title}}</el-link>
                          <el-row>
                            <el-col :span="24" class="WebNewsPaperDetail">
                              <div class="InnerDetail">
                                <div>{{m_Web__article.media_name}}</div>
                                <div>{{m_Web__article.reporting_date}}</div>
                              </div>
                              <!-- 2021/02/05 #10496 START -->
                              <!-- <div>
                                <img src="../../../assets/sp_image/New__Tab__Icon.png" alt="">
                              </div> -->
                              <!-- 2021/02/05 #10496 END -->
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col class="ariticle-bottom" v-if="m_Web__article.comment != '' && m_Web__article.comment != null ">
                          <ul>
                            <li>
                              <div class="message ico_comment_upSmall AllNewsico_comment_upSmall"></div>
                            </li>
                            <li>
                              <!-- 2022/08/01  #13357  START -->
                              <!-- <div
                                class="User__comment">{{m_Web__article.comment}}
                              </div> -->
                              <div class="User__comment" v-html="m_Web__article.comment"></div>
                              <!-- 2022/08/01  #13357  END -->
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  START -->
                  <!-- <p v-if="this.getIsTopPageInitialLoading || webLoading" class="centeralign_css_p">表示中...( {{ this.getWebArticledetails.length + 1 }}件 ～ {{ this.getWebArticledetails.length + 10 }}件 )</p> -->
                  <p v-if="(this.getIsTopPageInitialLoading || webLoading) && showWebbar" class="centeralign_css_p">表示中...( {{ this.getWebArticledetails.length + 1 }}件 ～ {{ this.getWebArticledetails.length + 10 }}件 )</p>
                  <!-- <p v-if="this.getIsTopPageInitialLoading == false && (IsWebNoMore)" class="centeralign_css_p">レコードがありません</p>  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (IsWebNoMore)" class="centeralign_css_p">レコードの最後です</p> 
                  <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  -->
                  <p v-if="this.getIsTopPageInitialLoading == false && (NoDefaultData)" class="centeralign_css_p">ヒット結果は0件です</p> 
                </el-collapse-item>
              </div>
            </el-collapse>
          </el-tab-pane>
        </el-tabs>
      </template>
    </el-row>
  </section>
</template>

<script>
// import draggable from 'vuedraggable';
import { mapGetters } from "vuex";
import Vue from "vue";
import VCalendar from "v-calendar-ie11";
import Common from '../../../common/CommonFunc.js';
import json from "../../../components/config.json";
import router from '../../../router';
// import router from '../../../router';
Vue.use(VCalendar);
var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
// 2024/12/11  #18790  START
//var FifteendaysBefore = CurrentDay - 15;
// 2024/12/11  #18790  END
// var newArr = [];
let defaultValue = [];
let secondTabDefaultValue = [];
export default {
  name: "Main0001",
  props: [],
  data() {
    return {
      AllTabs: "first",
       range: {
        //start: new Date(2020, 2, FifteendaysBefore), // Jan 16th, 2018
        // 2024/12/11  #18790  START
        //start: new Date(CurrentYear, CurrentMonth, FifteendaysBefore), // Jan 16th, 2018
        start: new Date(CurrentYear, CurrentMonth, CurrentDay), // Jan 16th, 2018
        // 2024/12/11  #18790  END
        end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
      },
      //2020/11/26  BT08460_EXTERNAL-1812  START
      showbar:true,
      showWebbar:true,
      showMagazinebar: true,
      //2020/11/26  BT08460_EXTERNAL-1812  END
      // 2022/02/14  #12197  START
      repeat:false,
      // 2022/02/14  #12197  END
      // 2023/03/27  #14161  START
      repeat1:false,
      // 2023/03/27  #14161  END
      // 2024/05/15  #17821  START
      csv_download_flag: false,
      // 2024/05/15  #17821  END
      setMailThemeValue: '',
      setMailThemeId: '',
      data_kbn: 1,
      isCollapse: true,
      activeName: "first",
      activeTab: "1",
      activeTab2: "1",
      activeTab3: "1",
      newsCount: "新聞 (0/0件)",
      newsSecondTabCount: "新聞 (0/0件)",
      webCount: "WEB (0/0件)",
      magazineCount: "雑誌 (0/0件)",
      newsLabel: '',
      themeValueDate: '',
      formInline: {
        user: "",
        region: ""
      },
      checkAll: false,
      secondTabCheckAll: false,
      checkAllWeb: false,
      checkAllMagazine: false,
      checkedNewsArticle: [],
      checkedSecondTabNewsArticle: [],
      checkedWebArticle: [],
      checkedMagazineArticle: [],
      isIndeterminate: true,
      drawer: false,
      direction: "rtl",
      credential: [],
      isNoticeExist:false,
      enabled: false,
      adminNotice: '',
      isShowing:false,
      userNotice: '',
      mc_pdf_view_flag: '',
      mc_pdf_print_flag: '',
      mc_text_view_flag: '',
      mc_text_print_flag: '',
      sc_pdf_view_flag: '',
      sc_pdf_print_flag: '',
      sc_text_view_flag: '',
      sc_text_print_flag: '',
      selected_theme_name: '',
      contractId: '',
      theme_browsing: '',
      defaultDateLoading: 0,
      startDateResult: '',
      endDateResult: '',
      newsSortCount: 0,
      pdf_confirm_message_flag: "",
      text_confirm_message_flag: "",
      collective_demand_max_count: "0",
      print_confirm_dialog_flag: "0",
      display_delay_message_min: "0",
      externalDbUrl: '',
      external_link_flag: false,
      //showNotification: false,
      showNotification: false,
      count: 10,
      loading: false,
      IsNoMore:false,
      webNewsCount: 10,
      magazineNewsCount: 10,
      webLoading: false,
      magazineLoading: false,
      IsWebNoMore:false,
      IsMagazineNoMore:false,
      NoDefaultData: false,
      NoDefaultMagazineData: false,
      NoDefaultNewsData: false,
      restrictArticleSortingDate: 0,
      flagForSetDefaultCount: 0,
      restrictDateFunction: 0,
      sendMailValue: 1,
      display_theme_mail_link_flag: '0',
      display_today_article_link_flag: false,
      news_article_flag: false,
      web_news_article_flag: false,
      user_group_news_article_flag: false,
      user_group_web_news_article_flag: false,
      today_article_label: "",
      contract_code: '',
      session_id: '',
      user_group_name: '',
      fullscreenLoading: false,
      pdf_usage_display_flag: false,
      // 2026/06/15  生成AI連携商用版対応  START
      //// 2025/12/23 生成AIサービス連携 START
      //ai_link_flag: false,
      //// 2025/12/23 生成AIサービス連携 END
      // 2026/06/15  生成AI連携商用版対応  END
      tabs:[],
      attributes: [
        {
          bar: {
            color: 'purple',
            class: 'my-dot-class',
          },
          dates: [],
        },
        {
          bar: 'purple',
          dates: [],
        },
        {
          bar: 'purple',
          dates: [],
        },
        {
          bar: 'purple',
          dates: [],
        },
      ],
    };
  },
  methods: {
    openEpub(contentsId,articleId,startPage,endPage){
      this.$LogButtonEvent("1019-002","OpenDialog");
      this.$LogMethodIN("1019-002","openEpub");

      var AID0102_InputParameters = {
        contents_id: contentsId,
        start_page: startPage,
        end_page: endPage,
        article_id: articleId
      };

      this.fullscreenLoading = true;
      this.$store.dispatch('communication1019002/AID0102_Get', AID0102_InputParameters).then(() => {
        this.fullscreenLoading = false;
        //After the Ajax call finished check if status is error for showing alert
        var status = this.getEpubDownloadErrStatus;
        var msgdetail = this.getEpubDownloadErrmsgDetail;
        if(status == "1")
        {
          this.$alert(msgdetail,"確認", {	confirmButtonText: 'OK',})
        }
        else
        {
          //console.log("else");
        }
      })
          .catch(() => {
            this.fullscreenLoading = false;
          })
      this.$LogMethodOut("1019-002","openEpub");
    },

    goToUserNoticeScreen(){
      router.push({name:"sp_0023"});
    },
    todayArticleLoading(){
      this.$LogButtonEvent("0001","TodayArticle");
      this.$LogMethodIN("0001","todayArticleLoading");      
      var inputParam;
      var webinputParam;
      var magazineinputParam;
      var totalNewsLabel;
      var webNewsLabel;
      var magazineLabel;
      this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {

        this.$store.commit('sp_Situation0001/setTodayArticleFlag', true);

        this.$store.commit('sp_Situation0001/setSearchConditionKey', 0);
        this.$store.commit('sp_Situation0001/setScRegisterFlag', true);
        this.$store.commit('sp_Situation0001/setWebregisterFlag', true);
        this.$store.commit('sp_Situation0001/setMagazineregisterFlag', true);
        this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
        this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
        this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);
        this.restrictDateFunction = 1;
        this.restrictArticleSortingDate = 1;
        //hide the mail link when today article link is displayed
        this.sendMailValue = 1;

        //parameter for api AID0005
        inputParam ={
          contract_id: this.contractId,
          process_date_start: this.startDateResult,
          process_date_end: this.endDateResult,
          sort_date: '',
          sort_title:'',
          Start_num:1,
          Load_num:10
        }

        this.fullscreenLoading = true;
        //Api call for get the news article
        this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
        this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
          totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
          this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
          this.today_article_label = this.getTodayArticleLabel;
          this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
          this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
          this.selected_theme_name = this.getSelectedLabel;
          this.restrictDateFunction = 0;
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // 2021/07/07  #11597  START
          //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
          this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
          // 2021/07/07  #11597  END
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
          this.fullscreenLoading = false;
          this.load();
        }).catch(()=>{
          totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
          this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
          this.today_article_label = this.getTodayArticleLabel;
          this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
          this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
          this.selected_theme_name = this.getSelectedLabel;
          this.restrictDateFunction = 0;
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // 2021/07/07  #11597  START
          //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
          this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
          // 2021/07/07  #11597  END
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
          this.fullscreenLoading = false;
          this.load();
        })
      
        //parameter for api AID0005
        webinputParam ={
          contract_id: this.contractId,
          data_section: 3,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10
        }
        
        this.fullscreenLoading = true;
        //Api call to get web article
        this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
        this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
          webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
          this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
          this.today_article_label = this.getTodayArticleLabel;
          this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
          this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
          this.selected_theme_name = this.getSelectedLabel;
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // 2021/07/07  #11597  START
          //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
          this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
          // 2021/07/07  #11597  END
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
          this.fullscreenLoading = false;
          this.webLoad();
        }).catch(()=>{
          webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
          this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
          this.today_article_label = this.getTodayArticleLabel;
          this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
          this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
          this.selected_theme_name = this.getSelectedLabel;
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
          // 2021/07/07  #11597  START
          //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
          this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
          // 2021/07/07  #11597  END
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
          this.fullscreenLoading = false;
          this.webLoad();
        })

        magazineinputParam ={
          contract_id: this.contractId,
          data_section: 5,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10
        }

        this.fullscreenLoading = true;
        //Api call to get web article
        this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
        this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
          magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
          this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
          this.today_article_label = this.getTodayArticleLabel;
          this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
          this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
          this.selected_theme_name = this.getSelectedLabel;
          this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
          this.fullscreenLoading = false;
          this.magazineLoad();
        }).catch(()=>{
          magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
          this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
          this.today_article_label = this.getTodayArticleLabel;
          this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
          this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
          this.selected_theme_name = this.getSelectedLabel;
          this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
          this.fullscreenLoading = false;
          this.magazineLoad();
        })
        this.drawer = false;
      })
      this.$LogMethodOut("0001","todayArticleLoading");
    },
    load() {    
      this.noMore();
      if (this.loading == false) {
        // If already loading it will not run.
        console.log(' --- ---- ---- ---- ')
        console.log(this.getMobNewsArticles.length)
        console.log(this.getThemeNewsCount)
        // TOOD: if we retirve all article for the given 
        if(this.getThemeNewsCount == 0 || this.getMobNewsArticles.length >= this.getThemeNewsCount)
        {
          this.count = this.getMaxArticleCountPerPage;
        }
        else
        {
          //2020/11/26  BT08460_EXTERNAL-1812  START
          this.showbar=true
          //2020/11/26  BT08460_EXTERNAL-1812  END
          this.setLoading(true);
          console.log("this.articleList.count");
          console.log(this.count);
          if(this.count > this.getThemeNewsCount)
          {
            // if the next retriving count is greater then total count, then resettting to max.
            this.count = this.getThemeNewsCount;
            console.log(this.count);
            this.setLoading(false,"second if");
          }
          else
          {
            // 2022/08/03  #12275  START
            //this.count += this.getMaxArticleCountPerPage; // change to static.
            //var themeValue = this.getSelectedTheme[0].value
            //var theme_id = this.getSelectedTheme[0].id
            // 2022/08/03  #12275  END
            var startNumCount = this.getMobNewsArticles.length + 1
            var inputParam;
            console.log(this.getSearchConditionKey);
            console.log(this.getTodayArticleFlag);
            console.log(this.getScRegisterFlag);
            if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
            {
              // 2022/08/03  #12275  START
              this.count += this.getMaxArticleCountPerPage; // change to static.
              var themeValue = this.getSelectedTheme[0].value
              var theme_id = this.getSelectedTheme[0].id
              // 2022/08/03  #12275  END
              if(themeValue == "Theme")
              {
                inputParam = {
                  contract_id: this.contractId,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  theme_id: theme_id
                };
              }
              else if(themeValue == "Theme Group")
              {
                inputParam = {
                  contract_id: this.contractId,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  theme_group_id: theme_id
                };
              }
              else
              {
                inputParam = {
                  contract_id: this.contractId,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  topics_id: theme_id
                };
              }

              var existingArticleDetails = [];

              existingArticleDetails = [...existingArticleDetails, inputParam, this.getMobNewsArticles];

              this.$store.dispatch('sp_Communication0001/getNewspaperArticles', existingArticleDetails)
              .then(() => {
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                }
                else
                {
                  this.newsCount = "新聞 (未登録)";
                  // this.newsSecondTabCount = "新聞 (未登録)";
                }
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showbar=false
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showbar=false
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              });

            }
            else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
            {
              
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title: this.getArticleTitle,
                Start_num: startNumCount,
                Load_num: this.getMaxArticleCountPerPage
              };
              

              var existingTodayArticleDetails = [];

              existingTodayArticleDetails = [...existingTodayArticleDetails, inputParam, this.getMobNewsArticles];

              this.$store.dispatch('sp_Communication0001/getNewspaperArticles', existingTodayArticleDetails)
              .then(() => {
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                }
                else
                {
                  this.newsCount = "新聞 (未登録)";
                  // this.newsSecondTabCount = "新聞 (未登録)";
                }
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showbar=false
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showbar=false
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              });
            }
            else if(this.getSearchConditionKey == 1)
            {
              if(this.getSearchValue != '')//if value is selected from search dropdown
              {
                inputParam = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getArticleDate,
                  search_title: this.getSearchValue,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  sort_title: this.getArticleTitle
                    
                }
              }
              else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  inputParam = {
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 1,
                    display_id: "SID0002",
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    key_word: this.getKeywordValue,
                    media_name: this.getMediaValue,
                    sort_date: this.getArticleDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_title: this.getArticleTitle
                  }
                }
                else//if media texbox is equal to empty
                {
                  inputParam = {
                    contract_id: this.contractId,
                    contract_kbn: 1,
                    display_id: "SID0002",
                    user_id: this.userId,
                    key_word: this.getKeywordValue,
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_date: this.getArticleDate,
                    sort_title: this.getArticleTitle,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
              else//if keyword textbox is equal to empty
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  inputParam = {
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 1,
                    display_id: "SID0002",
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    media_name: this.getMediaValue,
                    sort_date: this.getArticleDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_title: this.getArticleTitle
                  }
                }
                else//if media texbox is equal to empty
                {
                  inputParam = {
                    contract_id: this.contractId,
                    contract_kbn: 1,
                    display_id: "SID0002",
                    user_id: this.userId,
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_date: this.getArticleDate,
                    sort_title: this.getArticleTitle,
                    theme_browsing: this.theme_browsing
                  }
                }
              }

              var existingSearchArticleDetails = [];

              existingSearchArticleDetails = [...existingSearchArticleDetails, inputParam, this.getMobNewsArticles];

              this.$store.dispatch('sp_Communication0001/getNewsArticleUsingSorting', existingSearchArticleDetails)
              .then(() => {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showbar=false
                //2020/11/26  BT08460_EXTERNAL-1812  END
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showbar=false
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              });
            }
            else
            {
              //no action needed
            }
          
          }
        }
        
      }
      else
      {
        //no action needed
      }
      this.noMore();
    },
    setLoading(isLoading){
      this.loading = isLoading;
    },
    noMore () {
      if(this.getThemeNewsCount == 0)
      {
        this.IsNoMore = false;
        this.NoDefaultNewsData = true;
      }
      else
      {
        this.IsNoMore = this.getThemeNewsCount <= this.getMobNewsArticles.length;
        this.NoDefaultNewsData = false;
      }
      if(this.IsNoMore == true || this.NoDefaultNewsData == true){
        // if noMore is true, then we are setting this.loading to false.
        this.setLoading(false,'NoMore');
      }
    },
    magazineLoad() {
      this.magazineNoMore();
      if (this.magazineLoading == false) {
        if(this.getThemeMagazineCount == 0 || this.getMagazineArticledetails.length >= this.getThemeMagazineCount)
        {
          this.magazineNewsCount = this.getMaxArticleCountPerPage;
        }
        else
        {
          this.magazineSetLoading(true);
          if(this.magazineNewsCount > this.getThemeMagazineCount)
          {
            // if the next retriving count is greater then total count, then resettting to max.
            this.magazineNewsCount = this.getThemeMagazineCount;
            this.magazineSetLoading(false,"second if");
          }
          else
          {
            //2020/11/26  BT08460_EXTERNAL-1812  START
            this.showMagazinebar=true;
            //2020/11/26  BT08460_EXTERNAL-1812  END
            // 2022/08/03  #12275  START
            //this.magazineNewsCount += this.getMaxArticleCountPerPage; // change to static.
            //var themeValue = this.getSelectedTheme[0].value
            //var theme_id = this.getSelectedTheme[0].id
            // 2022/08/03  #12275  END
            var startNumCount = this.getMagazineArticledetails.length + 1
            var magazineinputParam;
            if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
            {
              // 2022/08/03  #12275  START
              this.magazineNewsCount += this.getMaxArticleCountPerPage; // change to static.
              var themeValue = this.getSelectedTheme[0].value
              var theme_id = this.getSelectedTheme[0].id
              // 2022/08/03  #12275  END
              if(themeValue == "Theme")
              {
                magazineinputParam = {
                  contract_id: this.contractId,
                  data_section: 5,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getMagazineArticleDate,
                  sort_title: this.getMagazineArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  theme_id: theme_id
                };
              }
              else if(themeValue == "Theme Group")
              {
                magazineinputParam = {
                  contract_id: this.contractId,
                  data_section: 5,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getMagazineArticleDate,
                  sort_title: this.getMagazineArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  theme_group_id: theme_id
                };
              }
              else
              {
                magazineinputParam = {
                  contract_id: this.contractId,
                  data_section: 5,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getMagazineArticleDate,
                  sort_title: this.getMagazineArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  topics_id: theme_id
                };
              }

              var existingArticleDetails = [];

              existingArticleDetails = [...existingArticleDetails, magazineinputParam, this.getMagazineArticledetails];

              this.$store.dispatch('sp_Communication0001/getMagazineArticles', existingArticleDetails)
                  .then(() => {
                    this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                    //2020/11/26  BT08460_EXTERNAL-1812  START
                    this.showMagazinebar=false;
                    //2020/11/26  BT08460_EXTERNAL-1812  END
                    setTimeout(() => {
                      this.magazineSetLoading(false);
                    }, 500);
                  }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showMagazinebar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.magazineSetLoading(false);
                }, 500);
              });

            }
            else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
            {

              magazineinputParam = {
                contract_id: this.contractId,
                data_section: 5,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getMagazineArticleDate,
                sort_title: this.getMagazineArticleTitle,
                Start_num: startNumCount,
                Load_num: this.getMaxArticleCountPerPage
              };

              var existingTodayArticleDetails = [];

              existingTodayArticleDetails = [...existingTodayArticleDetails, magazineinputParam, this.getMagazineArticledetails];

              this.$store.dispatch('sp_Communication0001/getMagazineArticles', existingTodayArticleDetails)
                  .then(() => {
                    this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                    //2020/11/26  BT08460_EXTERNAL-1812  START
                    this.showMagazinebar=false;
                    //2020/11/26  BT08460_EXTERNAL-1812  END
                    setTimeout(() => {
                      this.magazineSetLoading(false);
                    }, 500);
                  }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showMagazinebar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.magazineSetLoading(false);
                }, 500);
              });

            }
            else if(this.getSearchConditionKey == 1)
            {
              if(this.getSearchValue != '')//if value is selected from search dropdown
              {
                magazineinputParam = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 5,
                  display_id: 'SID0002',
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getMagazineArticleDate,
                  search_title: this.getSearchValue,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  sort_title: this.getMagazineArticleTitle

                }
              }
              else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  magazineinputParam = {
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 5,
                    display_id: "SID0002",
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    key_word: this.getKeywordValue,
                    media_name: this.getMediaValue,
                    sort_date: this.getMagazineArticleDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_title: this.getMagazineArticleTitle
                  }
                }
                else//if media texbox is equal to empty
                {
                  magazineinputParam = {
                    contract_id: this.contractId,
                    contract_kbn: 5,
                    display_id: "SID0002",
                    user_id: this.userId,
                    key_word: this.getKeywordValue,
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_date: this.getMagazineArticleDate,
                    sort_title: this.getMagazineArticleTitle,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
              else//if keyword textbox is equal to empty
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  magazineinputParam = {
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 5,
                    display_id: "SID0002",
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    media_name: this.getMediaValue,
                    sort_date: this.getMagazineArticleDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_title: this.getMagazineArticleTitle
                  }
                }
                else//if media texbox is equal to empty
                {
                  magazineinputParam = {
                    contract_id: this.contractId,
                    contract_kbn: 5,
                    display_id: "SID0002",
                    user_id: this.userId,
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_date: this.getMagazineArticleDate,
                    sort_title: this.getMagazineArticleTitle,
                    theme_browsing: this.theme_browsing
                  }
                }
              }

              var existingSearchArticleDetails = [];

              existingSearchArticleDetails = [...existingSearchArticleDetails, magazineinputParam, this.getMagazineArticledetails]

              this.$store.dispatch('sp_Communication0001/getMagazineArticleUsingSorting', existingSearchArticleDetails)
                  .then(() => {
                    this.magazineNewsCount = "雑誌 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeMagazineCount + "件)";
                    //2020/11/26  BT08460_EXTERNAL-1812  START
                    this.showMagazinebar=false;
                    //2020/11/26  BT08460_EXTERNAL-1812  END
                    setTimeout(() => {
                      this.magazineSetLoading(false);
                    }, 500);
                  }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showMagazinebar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.magazineSetLoading(false);
                }, 500);
              });
            }

          }
        }

      }
      else
      {
        //No action needed
      }
      this.magazineNoMore();

    },
    magazineSetLoading(isLoading){
      this.magazineLoading = isLoading;
    },
    magazineNoMore () {

      if(this.getThemeMagazineCount == 0)
      {
        this.IsMagazineNoMore = false
        this.NoDefaultMagazineData = true
      }
      else
      {
        this.IsMagazineNoMore = this.getThemeMagazineCount <= this.getMagazineArticledetails.length;
        this.NoDefaultMagazineData = false
      }
      if(this.IsMagazineNoMore == true || this.NoDefaultMagazineData == true){
        // if noMore is true, then we are setting this.loading to false.
        this.magazineSetLoading(false,'NoMore');
      }
    },

    webLoad() {
      this.webNoMore();
      if (this.webLoading == false) {      
        // If already loading it will not run.
        console.log(' --- ---- ---- --- ')
        console.log(this.getThemeWebCount)
        // TOOD: if we retirve all article for the given 
        if(this.getThemeWebCount == 0 || this.getWebArticledetails.length >= this.getThemeWebCount)
        {
          this.webNewsCount = this.getMaxArticleCountPerPage;
        }
        else
        {
          this.webSetLoading(true);
          console.log("this.articleList.count");
          console.log(this.webNewsCount)
          if(this.webNewsCount > this.getThemeWebCount)
          {
            // if the next retriving count is greater then total count, then resettting to max.
            this.webNewsCount = this.getThemeWebCount;
            console.log(this.webNewsCount)
            this.webSetLoading(false,"second if");
          }
          else
          {
            //2020/11/26  BT08460_EXTERNAL-1812  START
            this.showWebbar=true;
            //2020/11/26  BT08460_EXTERNAL-1812  END
            // 2022/08/03  #12275  START
            //this.webNewsCount += this.getMaxArticleCountPerPage; // change to static.
            //var themeValue = this.getSelectedTheme[0].value
            //var theme_id = this.getSelectedTheme[0].id
            // 2022/08/03  #12275  END
            var startNumCount = this.getWebArticledetails.length + 1
            var webinputParam;
            if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
            {
              // 2022/08/03  #12275  START
              this.webNewsCount += this.getMaxArticleCountPerPage; // change to static.
              var themeValue = this.getSelectedTheme[0].value
              var theme_id = this.getSelectedTheme[0].id
              // 2022/08/03  #12275  END
              if(themeValue == "Theme")
              {
                webinputParam = {
                  contract_id: this.contractId,
                  data_section: 3,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getWebArticleDate,
                  sort_title: this.getWebArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  theme_id: theme_id
                };
              }
              else if(themeValue == "Theme Group")
              {
                webinputParam = {
                  contract_id: this.contractId,
                  data_section: 3,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getWebArticleDate,
                  sort_title: this.getWebArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  theme_group_id: theme_id
                };
              }
              else
              {
                webinputParam = {
                  contract_id: this.contractId,
                  data_section: 3,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: this.getWebArticleDate,
                  sort_title: this.getWebArticleTitle,
                  Start_num: startNumCount,
                  Load_num: this.getMaxArticleCountPerPage,
                  topics_id: theme_id
                };
              }

              var existingArticleDetails = [];

              existingArticleDetails = [...existingArticleDetails, webinputParam, this.getWebArticledetails];

              this.$store.dispatch('sp_Communication0001/getWebArticles', existingArticleDetails)
              .then(() => {
                
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showWebbar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.webSetLoading(false);
                }, 500);
              }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showWebbar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.webSetLoading(false);
                }, 500);
              });

            }
            else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
            {
              
              webinputParam = {
                contract_id: this.contractId,
                data_section: 3,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getWebArticleDate,
                sort_title: this.getWebArticleTitle,
                Start_num: startNumCount,
                Load_num: this.getMaxArticleCountPerPage
              };

              var existingTodayArticleDetails = [];

              existingTodayArticleDetails = [...existingTodayArticleDetails, webinputParam, this.getWebArticledetails];

              this.$store.dispatch('sp_Communication0001/getWebArticles', existingTodayArticleDetails)
              .then(() => {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showWebbar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.webSetLoading(false);
                }, 500);
              }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showWebbar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.webSetLoading(false);
                }, 500);
              });

            }
            else if(this.getSearchConditionKey == 1)
            {
              if(this.getSearchValue != '')//if value is selected from search dropdown
              {
                webinputParam = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getWebArticleDate,
                  search_title: this.getSearchValue,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  sort_title: this.getWebArticleTitle
                    
                }
              }
              else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  webinputParam = {
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 2,
                    display_id: "SID0002",
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    key_word: this.getKeywordValue,
                    media_name: this.getMediaValue,
                    sort_date: this.getWebArticleDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_title: this.getWebArticleTitle
                  }
                }
                else//if media texbox is equal to empty
                {
                  webinputParam = {
                    contract_id: this.contractId,
                    contract_kbn: 2,
                    display_id: "SID0002",
                    user_id: this.userId,
                    key_word: this.getKeywordValue,
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_date: this.getWebArticleDate,
                    sort_title: this.getWebArticleTitle,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
              else//if keyword textbox is equal to empty
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  webinputParam = {
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 2,
                    display_id: "SID0002",
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    media_name: this.getMediaValue,
                    sort_date: this.getWebArticleDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_title: this.getWebArticleTitle
                  }
                }
                else//if media texbox is equal to empty
                {
                  webinputParam = {
                    contract_id: this.contractId,
                    contract_kbn: 2,
                    display_id: "SID0002",
                    user_id: this.userId,
                    process_date_from: this.getSearchStartDate,
                    process_date_to: this.getSearchEndDate,
                    start_num: startNumCount,
                    load_num: this.getMaxArticleCountPerPage,
                    sort_date: this.getWebArticleDate,
                    sort_title: this.getWebArticleTitle,
                    theme_browsing: this.theme_browsing
                  }
                }
              }

              var existingSearchArticleDetails = [];

              existingSearchArticleDetails = [...existingSearchArticleDetails, webinputParam, this.getWebArticledetails]

              this.$store.dispatch('sp_Communication0001/getWebArticleUsingSorting', existingSearchArticleDetails)
              .then(() => {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showWebbar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.webSetLoading(false);
                }, 500);
              }).catch(()=>{
                //2020/11/26  BT08460_EXTERNAL-1812  START
                this.showWebbar=false;
                //2020/11/26  BT08460_EXTERNAL-1812  END
                setTimeout(() => {
                  this.webSetLoading(false);
                }, 500);
              });
            }
          
          }
        }
        
      }
      else
      {
        //No action needed
      }
      this.webNoMore();
      
    },
    webSetLoading(isLoading){
      this.webLoading = isLoading;
    },
    webNoMore () {
      
      if(this.getThemeWebCount == 0)
      {
        this.IsWebNoMore = false
        this.NoDefaultData = true
      }
      else
      {
        this.IsWebNoMore = this.getThemeWebCount <= this.getWebArticledetails.length;
        this.NoDefaultData = false
      }
      if(this.IsWebNoMore == true || this.NoDefaultData == true){
        // if noMore is true, then we are setting this.loading to false.
        this.webSetLoading(false,'NoMore');
      }
    },
    goToSearchScreen(){
      this.$LogButtonEvent("0001","ArticleSearch");
      this.$LogMethodIN("0001","goToSearchScreen");
      // this.$store.commit('sp_Situation0001/setSearchConditionKey', 1);
      this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
      router.push({name:"sp_0002"});
      this.$LogMethodOut("0001","goToSearchScreen");
    },
    handleThemeValue(value, id, label, newsCount, webCount, scFlag, webFlag,magazineCount,magazineFlag){
      this.$LogButtonEvent("0001","SelectTheme");
      this.$LogMethodIN("0001","handleThemeValue");

      if(this.getSearchConditionKey == 3)
      {
        this.range.start = ''
        this.range.end = ''

        this.range = {
          start: new Date(this.startDateResult),
          end: new Date(this.endDateResult)
        }

      }
      else
      {
        //no action needed
      }

      this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {

        this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);

        this.$store.commit('sp_Situation0001/setArticleTitle', '');
        this.$store.commit('sp_Situation0001/setArticleDate', '');

        this.$store.commit('sp_Situation0001/setWebArticleDate', '');
        this.$store.commit('sp_Situation0001/setWebArticleTitle', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleDate', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleTitle', '');
        this.$store.commit('sp_Situation0001/setScRegisterFlag', scFlag);
        this.$store.commit('sp_Situation0001/setWebregisterFlag', webFlag);
        this.$store.commit('sp_Situation0001/setMagazineregisterFlag', magazineFlag);
        this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', id);
        this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
        this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);

        if(this.getScRegisterFlag == true)
        {
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
        }
        else
        {
          this.newsCount = "新聞 (未登録)";
          // this.newsSecondTabCount = "新聞 (未登録)";
        }
        if(this.getWebRegisterFlag == true)
        {
          // 2021/07/07  #11597  START
          //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
          this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
          // 2021/07/07  #11597  END
        }
        else
        {
          this.webCount = "WEB (未登録)";
        }

        if(this.getMagazineRegisterFlag == true)
        {
          this.magazineCount = "雑誌 (0" + "/" + this.getThemeMagazineCount + "件)"
        }
        else
        {
          this.magazineCount = "雑誌 (未登録)";
        }

        //set selected theme value for passing to 0003 page as query parameter
        this.setMailThemeValue = label;
        //set selected theme id for passing to 0003 page as query parameter
        this.setMailThemeId = id;
        //set data_kbn for passing to 0003 page as query parameter
        this.data_kbn = 1;
        // var theme_label = value;
        this.flagForSetDefaultCount = 0;
        this.restrictArticleSortingDate = 1;
        this.sendMailValue = 0;
        this.selected_theme_name = value;
        var inputParam;
        var webinputParam;
        var magazineinputParam;
        var selectedTheme = [];
        var searchKey = 0;
        // var themeCheck = 1
        selectedTheme = [{value: "Theme", id: id}];
        this.themeValueDate = "Theme";
        //commit the selected theme to situation for sorting the article based on selected value
        this.$store.commit("sp_Situation0001/setSelectedTheme", selectedTheme);
        this.$store.commit('sp_Situation0001/setSearchConditionKey', searchKey);
        this.$store.commit("sp_Situation0001/setThemeNewsCount", newsCount);
        this.$store.commit('sp_Situation0001/setThemeWebCount', webCount);
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', magazineCount);
        this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
        this.$store.commit('sp_Situation0001/setSelectedLabel', this.selected_theme_name);

        this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
        this.checkedNewsArticle = [];
        this.checkAll = false;
        this.checkedSecondTabNewsArticle = [];
        this.secondTabCheckAll = false;
        //parameter for newspaper article with theme_id(AID0005)
        inputParam ={
          contract_id: this.contractId,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date: '',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          theme_id: id
        }
        //parameter for web article with theme_id(AID0006)
        webinputParam ={
          contract_id: this.contractId,
          data_section: 3,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          theme_id: id
        }
        magazineinputParam ={
          contract_id: this.contractId,
          data_section: 5,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          theme_id: id
        }
        var totalNewsLabel;
        if(this.getThemeNewsCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call for displaying the News article based on selected theme
          this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getScRegisterFlag)
            {
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            }
            else
            {
              this.newsCount = "新聞 (未登録)";
              // this.newsSecondTabCount = "新聞 (未登録)";
            }
            totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
            this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
            this.load();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getScRegisterFlag)
          {
            this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
          }
          else
          {
            this.newsCount = "新聞 (未登録)";
            // this.newsSecondTabCount = "新聞 (未登録)";
          }
          totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
          this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
          this.load();
        }

        var webNewsLabel;
        if(this.getThemeWebCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call to get web article based on selected theme
          this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getWebRegisterFlag)
            {
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
              this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
              // 2021/07/07  #11597  END
            }
            else
            {
              this.webCount = "WEB (未登録)";
            }
            webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
            this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
            this.webLoad();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getWebRegisterFlag)
          {
            // 2021/07/07  #11597  START
            //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
            this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
            // 2021/07/07  #11597  END
          }
          else
          {
            this.webCount = "WEB (未登録)";
          }
          webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
          this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
          this.webLoad();
        }
        var magazineNewsLabel;
        if(this.getThemeMagazineCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call to get web article based on selected theme
          this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getMagazineRegisterFlag)
            {
              this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
            }
            else
            {
              this.magazineCount = "雑誌 (未登録)";
            }
            magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
            this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineNewsLabel, { root: true });
            this.magazineLoad();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getMagazineRegisterFlag)
          {
            this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
          }
          else
          {
            this.magazineCount = "雑誌 (未登録)";
          }
          magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
          this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineNewsLabel, { root: true });
          this.magazineLoad();
        }
        this.drawer = false
      })
      this.$LogMethodOut("0001","handleThemeValue");
    },
    handleThemeGroupValue(value, id, label, newsCount, webCount, scFlag, webFlag,magazineCount,magazineFlag){
      this.$LogButtonEvent("0001","SelectThemeGroup");
      this.$LogMethodIN("0001","handleThemeGroupValue");

      if(this.getSearchConditionKey == 3)
      {
        this.range.start = ''
        this.range.end = ''

        this.range = {
          start: new Date(this.startDateResult),
          end: new Date(this.endDateResult)
        }

      }
      else
      {
        //no action needed
      }

      this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {

        this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);

        this.$store.commit('sp_Situation0001/setScRegisterFlag', scFlag);
        this.$store.commit('sp_Situation0001/setWebregisterFlag', webFlag);
        this.$store.commit('sp_Situation0001/setMagazineregisterFlag', magazineFlag);
        this.$store.commit('sp_Situation0001/setArticleTitle', '');
        this.$store.commit('sp_Situation0001/setArticleDate', '');

        this.$store.commit('sp_Situation0001/setWebArticleDate', '');
        this.$store.commit('sp_Situation0001/setWebArticleTitle', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleDate', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleTitle', '');
        this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
        this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', id);
        this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);

        if(this.getScRegisterFlag == true)
        {
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
        }
        else
        {
          this.newsCount = "新聞 (未登録)";
          // this.newsSecondTabCount = "新聞 (未登録)";
        }
        if(this.getWebRegisterFlag == true)
        {
          // 2021/07/07  #11597  START
          //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
          this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
          // 2021/07/07  #11597  END
        }
        else
        {
          this.webCount = "WEB (未登録)";
        }
        if(this.getMagazineRegisterFlag == true)
        {
          this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
        }
        else
        {
          this.magazineCount = "雑誌 (未登録)";
        }
        //set selected theme value for passing to 0003 page as query parameter
        this.setMailThemeValue = value;
        //set selected theme id for passing to 0003 page as query parameter
        this.setMailThemeId = id;
        //set data_kbn for passing to 0003 page as query parameter
        this.data_kbn = 2;
        // var theme_label = value;
        this.flagForSetDefaultCount = 0;
        this.restrictArticleSortingDate = 1;
        this.sendMailValue = 0;
        this.selected_theme_name = label;
        var inputParam;
        var webinputParam;
        var magazineinputParam;
        var selectedTheme = [];
        var searchKey = 0;
        // var themeCheck = 1
        selectedTheme = [{value: "Theme Group", id: id}];
        this.themeValueDate = "Theme Group";
        //commit the selected theme to situation for sorting the article based on selected value
        this.$store.commit("sp_Situation0001/setSelectedTheme", selectedTheme);
        this.$store.commit('sp_Situation0001/setSearchConditionKey', searchKey);
        this.$store.commit("sp_Situation0001/setThemeNewsCount", newsCount);
        this.$store.commit('sp_Situation0001/setThemeWebCount', webCount);
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', magazineCount);
        this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
        this.$store.commit('sp_Situation0001/setSelectedLabel', this.selected_theme_name);

        this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
        this.checkedNewsArticle = [];
        this.checkAll = false;
        this.checkedSecondTabNewsArticle = [];
        this.secondTabCheckAll = false;
        //parameter for newspaper article with theme_id(AID0005)
        inputParam ={
          contract_id: this.contractId,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date: '',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          theme_group_id: id
        }
        //parameter for web article with theme_id(AID0006)
        webinputParam ={
          contract_id: this.contractId,
          data_section: 3,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          theme_group_id: id
        }
        magazineinputParam ={
          contract_id: this.contractId,
          data_section: 5,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          theme_group_id: id
        }
        var totalNewsLabel;
        if(this.getThemeNewsCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call for displaying the News article based on selected theme
          this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getScRegisterFlag)
            {
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            }
            else
            {
              this.newsCount = "新聞 (未登録)";
              // this.newsSecondTabCount = "新聞 (未登録)";
            }
            totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
            this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
            this.load();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getScRegisterFlag)
          {
            this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
          }
          else
          {
            this.newsCount = "新聞 (未登録)";
            // this.newsSecondTabCount = "新聞 (未登録)";
          }
          totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
          this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
          this.load();
        }

        var webNewsLabel;
        if(this.getThemeWebCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call to get web article based on selected theme
          this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getWebRegisterFlag)
            {
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
              this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
              // 2021/07/07  #11597  END
            }
            else
            {
              this.webCount = "WEB (未登録)";
            }
            webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
            this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
            this.webLoad();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getWebRegisterFlag)
          {
            // 2021/07/07  #11597  START
            //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
            this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
            // 2021/07/07  #11597  END
          }
          else
          {
            this.webCount = "WEB (未登録)";
          }
          webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
          this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
          this.webLoad();
        }
        var magazineNewsLabel;
        if(this.getThemeMagazineCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call to get web article based on selected theme
          this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getMagazineRegisterFlag)
            {
              this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
            }
            else
            {
              this.magazineCount = "雑誌 (未登録)";
            }
            magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
            this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineNewsLabel, { root: true });
            this.magazineLoad();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getMagazineRegisterFlag)
          {
            this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
          }
          else
          {
            this.magazineCount = "雑誌 (未登録)";
          }
          magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
          this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineNewsLabel, { root: true });
          this.magazineLoad();
        }
        this.drawer = false

      })
      this.$LogMethodOut("0001","handleThemeGroupValue");
    },
    handleTopicsValue(value, id, label, newsCount, webCount, scFlag, webFlag,magazineCount,magazineFlag){
      this.$LogButtonEvent("0001","SelectTopic");
      this.$LogMethodIN("0001","handleTopicsValue");

      if(this.getSearchConditionKey == 3)
      {
        this.range.start = ''
        this.range.end = ''

        this.range = {
          start: new Date(this.startDateResult),
          end: new Date(this.endDateResult)
        }

      }
      else
      {
        //no action needed
      }
      
      this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {

        this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);

        this.$store.commit('sp_Situation0001/setScRegisterFlag', scFlag);
        this.$store.commit('sp_Situation0001/setWebregisterFlag', webFlag);
        this.$store.commit('sp_Situation0001/setMagazineregisterFlag', magazineFlag);
        this.$store.commit('sp_Situation0001/setArticleTitle', '');
        this.$store.commit('sp_Situation0001/setArticleDate', '');

        this.$store.commit('sp_Situation0001/setWebArticleDate', '');
        this.$store.commit('sp_Situation0001/setWebArticleTitle', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleDate', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleTitle', '');
        this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
        this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
        this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', id);

        if(this.getScRegisterFlag == true)
        {
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
        }
        else
        {
          this.newsCount = "新聞 (未登録)";
          // this.newsSecondTabCount = "新聞 (未登録)";
        }
        if(this.getWebRegisterFlag == true)
        {
          // 2021/07/07  #11597  START
          //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
          this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
          // 2021/07/07  #11597  END
        }
        else
        {
          this.webCount = "WEB (未登録)";
        }
        if(this.getMagazineRegisterFlag == true)
        {
          this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
        }
        else
        {
          this.magazineCount = "雑誌 (未登録)";
        }
        //set selected theme value for passing to 0003 page as query parameter
        this.setMailThemeValue = label;
        //set selected theme id for passing to 0003 page as query parameter
        this.setMailThemeId = id;
        //set data_kbn for passing to 0003 page as query parameter
        this.data_kbn = 3
        // var theme_label = value;
        this.flagForSetDefaultCount = 0;
        this.restrictArticleSortingDate = 1;
        this.sendMailValue = 0;
        this.selected_theme_name = value;
        var inputParam;
        var webinputParam;
        var magazineinputParam;
        var selectedTheme = [];
        var searchKey = 0
        // var themeCheck = 1
        selectedTheme = [{value: "Topics", id: id}];
        this.themeValueDate = "Topics";
        //commit the selected theme to situation for sorting the article based on selected value
        this.$store.commit("sp_Situation0001/setSelectedTheme", selectedTheme);
        this.$store.commit('sp_Situation0001/setSearchConditionKey', searchKey);
        this.$store.commit("sp_Situation0001/setThemeNewsCount", newsCount);
        this.$store.commit('sp_Situation0001/setThemeWebCount', webCount);
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', magazineCount);
        this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
        this.$store.commit('sp_Situation0001/setSelectedLabel', this.selected_theme_name)

        this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
        this.checkedNewsArticle = [];
        this.checkAll = false;
        this.checkedSecondTabNewsArticle = [];
        this.secondTabCheckAll = false;
        //commit the theme label to situation for displaying the value in top page
        this.$store.commit("sp_Situation0001/setSelectedLabel", value);
        //parameter for newspaper article with theme_id(AID0005)
        inputParam ={
          contract_id: this.contractId,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date: '',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          topics_id: id
        }
        //parameter for web article with theme_id(AID0006)
        webinputParam ={
          contract_id: this.contractId,
          data_section: 3,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          topics_id: id
        }
        magazineinputParam ={
          contract_id: this.contractId,
          data_section: 5,
          process_date_start:this.startDateResult,
          process_date_end:this.endDateResult,
          sort_date:'',
          sort_title:'',
          Start_num:1,
          Load_num:10,
          topics_id: id
        }
        var totalNewsLabel;
        if(this.getThemeNewsCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call for displaying the News article based on selected theme
          this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getScRegisterFlag)
            {
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            }
            else
            {
              this.newsCount = "新聞 (未登録)";
              // this.newsSecondTabCount = "新聞 (未登録)"
            }
            totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
            this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
            this.load();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getScRegisterFlag)
          {
            this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
          }
          else
          {
            this.newsCount = "新聞 (未登録)";
            // this.newsSecondTabCount = "新聞 (未登録)";
          }
          totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
          this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
          this.load();
        }

        var webNewsLabel;
        if(this.getThemeWebCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call to get web article based on selected theme
          this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getWebRegisterFlag)
            {
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
              this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
              // 2021/07/07  #11597  END
            }
            else
            {
              this.webCount = "WEB (未登録)";
            }
            webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
            this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
            this.webLoad();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          this.webLoad();
          if(this.getWebRegisterFlag)
          {
            // 2021/07/07  #11597  START
            //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
            this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
            // 2021/07/07  #11597  END
          }
          else
          {
            this.webCount = "WEB (未登録)";
          }
          webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
          this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
        }
        var magazineNewsLabel;
        if(this.getThemeMagazineCount != 0)
        {
          this.fullscreenLoading = true;
          //Api call to get web article based on selected theme
          this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
            this.fullscreenLoading = false;
            if(this.getMagazineRegisterFlag)
            {
              this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
            }
            else
            {
              this.magazineCount = "雑誌 (未登録)";
            }
            magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
            this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineNewsLabel, { root: true });
            this.magazineLoad();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else
        {
          if(this.getMagazineRegisterFlag)
          {
            this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
          }
          else
          {
            this.magazineCount = "雑誌 (未登録)";
          }
          magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
          this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineNewsLabel, { root: true });
          this.magazineLoad();
        }
        this.drawer = false;
      })
     this.$LogMethodOut("0001","handleTopicsValue"); 
    },
    logoutfunction(){
      //router.push({name:'sp_0006'});
      this.$store.commit('sp_Situation0001/nikkieArticledata', []);
      this.$store.commit('sp_Situation0001/webArticleData', []);
      this.$store.commit('sp_Situation0001/magazineArticleData', []);
      this.$store.commit('sp_Situation0001/setTotalNewsCount', 0);
      this.$store.commit('sp_Situation0001/setTotalNewsLabel', "新聞(0件)");
      //reset the existing web article values
      this.$store.commit('sp_Situation0001/webArticleData', []);
      this.$store.commit('sp_Situation0001/setWebTotalNewsCount', 0);
      this.$store.commit('sp_Situation0001/setMagazineTotalNewsCount', 0);
      this.$store.commit('sp_Situation0001/setWebTotalLabel', "WEB(0件)");
      this.$store.commit('sp_Situation0001/setMagazineTotalLabel', "雑誌(0件)");
      this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", 0);
      this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
      this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0);
      this.$store.commit('sp_Situation0001/setArticleTitle', '');
      this.$store.commit('sp_Situation0001/setArticleDate', '');

      this.$store.commit('sp_Situation0001/setWebArticleDate', '');
      this.$store.commit('sp_Situation0001/setWebArticleTitle', '');
      this.$store.commit('sp_Situation0001/setMagazineArticleDate', '');
      this.$store.commit('sp_Situation0001/setMagazineArticleTitle', '');
      // 2022/08/02  #12275  START
      this.$store.commit('sp_Situation0001/setthemetopics', ['1']);
      this.$store.commit('sp_Situation0001/settheme', ['1']);
      this.$store.commit('sp_Situation0001/setthemegrouptopics', ['1']);
      this.$store.commit('sp_Situation0001/setThemeNewsCount', 0);
      this.$store.commit('sp_Situation0001/setThemeWebCount', 0);
      this.$store.commit('sp_Situation0001/setThemeMagazineCount', 0);
      // 2022/08/02  #12275  END
      this.$store.dispatch('sp_Communication0006/logout');
    },
    loadLatestDateArticle(){
      this.$LogButtonEvent("0001","LatestDayArticle");
      this.$LogMethodIN("0001","loadLatestDateArticle");
      if(this.range){
        this.range.start = ''
        this.range.end = ''
      }

      if(this.flagForSetDefaultCount == 1)
      {
        this.$store.commit("sp_Situation0001/setThemeNewsCount", Vue.prototype.$session.get('themeNewsCountAfterLogin'));
        this.$store.commit('sp_Situation0001/setThemeWebCount', Vue.prototype.$session.get('themeWebCountAfetrLogin'));
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', Vue.prototype.$session.get('themeMagazineCountAfetrLogin'));
      }

      this.restrictArticleSortingDate = 0;
      this.restrictDateFunction = 0;
      this.sendMailValue = 0;
      this.$store.commit('sp_Situation0001/setSearchConditionKey', 0);
      this.checkedNewsArticle = [];
      this.checkAll = false;
      this.checkedSecondTabNewsArticle = [];
      this.secondTabCheckAll = false;

      this.$store.commit('sp_Situation0001/setArticleTitle', '');
      this.$store.commit('sp_Situation0001/setArticleDate', '');

      this.$store.commit('sp_Situation0001/setWebArticleDate', '');
      this.$store.commit('sp_Situation0001/setWebArticleTitle', '');

      this.$store.commit('sp_Situation0001/setMagazineArticleDate', '');
      this.$store.commit('sp_Situation0001/setMagazineArticleTitle', '');

      this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {
        var latestNewsDate = this.getSortedElArticleDate[this.getSortedElArticleDate.length - 1]

        var sdate = new Date(latestNewsDate),
        smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
        sday = ("0" + sdate.getDate()).slice(-2);
        //convert the date format
        var startResult = [sdate.getFullYear(), smnth, sday].join("/");

        this.range = {
          start: new Date(startResult),
          end: new Date(startResult)
        }

        var themeDetails = {
          contract_id: this.contractId,
          theme_browsing: this.theme_browsing,
          user_id: this.userId,
          display_id: "SID0002",
          process_date_start: startResult,
          process_date_end: startResult
        };

        var existingArticleDetails = [];

        existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId];
        this.fullscreenLoading = true;
        //Api call to get article theme values
        this.$store.dispatch('sp_Communication0001/getTheme', existingArticleDetails).then(() => {
          this.fullscreenLoading = false;
          this.restrictArticleSortingDate = 1;
          var inputParam;
          var webinputParam;
          var magazineinputParam;
          var totalNewsLabel;
          var webNewsLabel;
          var magazineLabel;
          if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if date is changed for themes
          {
            if(this.themeValueDate == "Theme")
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:this.getWebArticleDate,
                sort_title:this.getWebArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:this.getMagazineArticleDate,
                sort_title:this.getMagazineArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }
            }
            else if(this.themeValueDate == "Theme Group")
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:this.getWebArticleDate,
                sort_title:this.getWebArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:this.getMagazineArticleDate,
                sort_title:this.getMagazineArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }
            }
            else
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:10,
                topics_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:this.getWebArticleDate,
                sort_title:this.getWebArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:this.getMagazineArticleDate,
                sort_title:this.getMagazineArticleTitle,
                Start_num:1,
                Load_num:10,
                theme_id:this.setMailThemeId
              }
            }

            if(this.getThemeNewsCount != 0)
            {
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
              this.fullscreenLoading = true;
              //Api call for get the news article
              this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                this.fullscreenLoading = false;
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                }
                else
                {
                  this.newsCount = "新聞 (未登録)";
                  // this.newsSecondTabCount = "新聞 (未登録)";
                }
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                this.selected_theme_name = this.getSelectedLabel;
                this.load();
              }).catch(() => {
                this.fullscreenLoading = false;
              })
            }
            else
            {
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
              this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
              this.selected_theme_name = this.getSelectedLabel;
              this.load();
            }

            if(this.getThemeWebCount != 0)
            {
              this.fullscreenLoading = true;
              //Api call to get web article
              this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
                this.fullscreenLoading = false;
                if(this.getWebRegisterFlag)
                {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
                }
                else
                {
                  this.webCount = "WEB (未登録)";
                }
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                this.selected_theme_name = this.getSelectedLabel;
                this.webLoad();
              }).catch(() => {
                this.fullscreenLoading = false;
              })
            }
            else
            {
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
              this.selected_theme_name = this.getSelectedLabel;
              this.webLoad();
            }

            if(this.getThemeMagazineCount != 0)
            {
              this.fullscreenLoading = true;
              //Api call to get web article
              this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
                this.fullscreenLoading = false;
                if(this.getMagazineRegisterFlag)
                {
                  this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                }
                else
                {
                  this.magazineCount = "雑誌 (未登録)";
                }
                magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                this.selected_theme_name = this.getSelectedLabel;
                this.magazineLoad();
              }).catch(() => {
                this.fullscreenLoading = false;
              })
            }
            else
            {
              if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
              this.selected_theme_name = this.getSelectedLabel;
              this.magazineLoad();
            }
          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
          {
            this.sendMailValue = 1;
            //parameter for api AID0005
            inputParam ={
              contract_id: this.contractId,
              process_date_start: startResult,
              process_date_end: startResult,
              sort_date: '',
              sort_title:'',
              Start_num:1,
              Load_num:10
            }
            
            this.fullscreenLoading = true;
            //Api call for get the news article
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
              totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
              this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
              this.today_article_label = this.getTodayArticleLabel;
              this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
              this.selected_theme_name = this.getSelectedLabel;
              // this.restrictDateFunction = 0;
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
              this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
              // 2021/07/07  #11597  END
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
              this.load();
            }).catch(()=>{
              totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
              this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
              this.today_article_label = this.getTodayArticleLabel;
              this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
              this.selected_theme_name = this.getSelectedLabel;
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
              this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
              // 2021/07/07  #11597  END
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
          
            //parameter for api AID0005
            webinputParam ={
              contract_id: this.contractId,
              data_section: 3,
              process_date_start:startResult,
              process_date_end:startResult,
              sort_date:'',
              sort_title:'',
              Start_num:1,
              Load_num:10
            }
            
            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
              webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
              this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
              this.today_article_label = this.getTodayArticleLabel;
              this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
              this.selected_theme_name = this.getSelectedLabel;
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
              this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
              // 2021/07/07  #11597  END
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
              this.webLoad();
            }).catch(()=>{
              webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
              this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
              this.today_article_label = this.getTodayArticleLabel;
              this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
              this.selected_theme_name = this.getSelectedLabel;
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
              this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
              // 2021/07/07  #11597  END
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
              this.webLoad();
            })

            magazineinputParam ={
              contract_id: this.contractId,
              data_section: 5,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date:'',
              sort_title:'',
              Start_num:1,
              Load_num:10
            }

            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
            this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
              magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
              this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
              this.today_article_label = this.getTodayArticleLabel;
              this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
              this.selected_theme_name = this.getSelectedLabel;
              this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
              this.magazineLoad();
            }).catch(()=>{
              magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
              this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
              this.today_article_label = this.getTodayArticleLabel;
              this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
              this.selected_theme_name = this.getSelectedLabel;
              this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
              this.magazineLoad();
            })
          }
        })


        this.startDateResult = startResult;
        this.endDateResult = startResult;
      })

      this.$LogMethodOut("0001","loadLatestDateArticle");
    },
    selectDateForSearch(){
      this.$LogButtonEvent("0001","SelectDate");
      this.$LogMethodIN("0001","selectDateForSearch");
      if(this.flagForSetDefaultCount == 1)
      {
        this.$store.commit("sp_Situation0001/setThemeNewsCount", Vue.prototype.$session.get('themeNewsCountAfterLogin'));
        this.$store.commit('sp_Situation0001/setThemeWebCount', Vue.prototype.$session.get('themeWebCountAfetrLogin'));
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', Vue.prototype.$session.get('themeMagazineCountAfetrLogin'));
      }
      console.log("datefunctioncalled")
      console.log(this.restrictArticleSortingDate)
      if(this.restrictArticleSortingDate == 1)
      {
        this.$store.commit('sp_Situation0001/setSearchConditionKey', 0);
        this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", 0);
        this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);

        this.checkedNewsArticle = [];
        this.checkAll = false;
        this.checkedSecondTabNewsArticle = [];
        this.secondTabCheckAll = false;

        this.$store.commit('sp_Situation0001/setArticleTitle', '');
        this.$store.commit('sp_Situation0001/setArticleDate', '');

        this.$store.commit('sp_Situation0001/setWebArticleDate', '');
        this.$store.commit('sp_Situation0001/setWebArticleTitle', '');

        this.$store.commit('sp_Situation0001/setMagazineArticleDate', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleTitle', '');
        //get the start date from the selected date
        var startDate = this.range.start;
        var sdate = new Date(startDate),
        smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
        sday = ("0" + sdate.getDate()).slice(-2);
        //convert the date format
        var startResult = [sdate.getFullYear(), smnth, sday].join("/");
        //get the end date from the selected date
        var endDate = this.range.end;
        var edate = new Date(endDate),
        emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
        eday = ("0" + edate.getDate()).slice(-2);
        //convert the date format
        // 2021/01/18 #10394 START
        //var endResult = [sdate.getFullYear(), emnth, eday].join("/");
        var endResult = [edate.getFullYear(), emnth, eday].join("/");
        // 2021/01/18 #10394 END

        this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {
          var themeDetails = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: startResult,
            process_date_end: endResult
          };

          var existingArticleDetails = [];

          existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId]

          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.$store.dispatch('sp_Communication0001/getTheme', existingArticleDetails).then(() => {
            this.fullscreenLoading = false;
            this.setMailThemeValue = this.getDefaultMailTheme;
            this.selected_theme_name = this.getSelectedLabel;
            this.setMailThemeId = this.getSelectedTheme[0].id;
            this.themeValueDate = this.getSelectedTheme[0].value;

            if(this.getIsDefaultDateLoading != 0 && this.restrictDateFunction == 0)
            {
              var inputParam;
              var webinputParam;
              var magazineinputParam;
              var totalNewsLabel;
              var webNewsLabel;
              var magazineLabel;
              if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if date is changed for themes
              {
                //make the mail transition link as clickable
                this.sendMailValue = 0;
                if(this.themeValueDate == "Theme")
                {
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date: this.getArticleDate,
                    sort_title:this.getArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_id:this.setMailThemeId
                  }
                  
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:this.getWebArticleDate,
                    sort_title:this.getWebArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_id:this.setMailThemeId
                  }
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:this.getMagazineArticleDate,
                    sort_title:this.getMagazineArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_id:this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date: this.getArticleDate,
                    sort_title:this.getArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                  
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:this.getWebArticleDate,
                    sort_title:this.getWebArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:this.getMagazineArticleDate,
                    sort_title:this.getMagazineArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                }
                else
                {
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date: this.getArticleDate,
                    sort_title:this.getArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    topics_id:this.setMailThemeId
                  }
                  
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:this.getWebArticleDate,
                    sort_title:this.getWebArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    topics_id:this.setMailThemeId
                  }
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:this.getMagazineArticleDate,
                    sort_title:this.getMagazineArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    topics_id:this.setMailThemeId
                  }
                }

                if(this.getThemeNewsCount != 0)
                {
                  this.fullscreenLoading = true;
                  //Api call for get the news article
                  this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                    this.fullscreenLoading = false;
                    if(this.getScRegisterFlag)
                    {
                      this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                      // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                    }
                    else
                    {
                      this.newsCount = "新聞 (未登録)";
                      // this.newsSecondTabCount = "新聞 (未登録)";
                    }
                    totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.load();
                  }).catch(() => {
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  if(this.getScRegisterFlag)
                  {
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  }
                  else
                  {
                    this.newsCount = "新聞 (未登録)";
                    // this.newsSecondTabCount = "新聞 (未登録)";
                  }
                  totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                  this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                  this.selected_theme_name = this.getSelectedLabel;
                  this.load();
                }

                if(this.getThemeWebCount != 0)
                {
                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
                    this.fullscreenLoading = false;
                    if(this.getWebRegisterFlag)
                    {
                      // 2021/07/07  #11597  START
                      //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                      this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                      // 2021/07/07  #11597  END
                    }
                    else
                    {
                      this.webCount = "WEB (未登録)";
                    }
                    webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                    this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.webLoad();
                  }).catch(() => {
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  if(this.getWebRegisterFlag)
                  {
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                    this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                    // 2021/07/07  #11597  END
                  }
                  else
                  {
                    this.webCount = "WEB (未登録)";
                  }
                  webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                  this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                  this.selected_theme_name = this.getSelectedLabel;
                  this.webLoad();
                }

                if(this.getThemeMagazineCount != 0)
                {
                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
                    this.fullscreenLoading = false;
                    if(this.getMagazineRegisterFlag)
                    {
                      this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                    }
                    else
                    {
                      this.magazineCount = "雑誌 (未登録)";
                    }
                    magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.magazineLoad();
                  }).catch(() => {
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  if(this.getMagazineRegisterFlag)
                  {
                    this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                  }
                  else
                  {
                    this.magazineCount = "雑誌 (未登録)";
                  }
                  magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                  this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                  this.selected_theme_name = this.getSelectedLabel;
                  this.magazineLoad();
                }
              }
              else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if date is changed for today's article link
              {
                this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {

                  this.$store.commit('sp_Situation0001/setScRegisterFlag', true);
                  this.$store.commit('sp_Situation0001/setWebregisterFlag', true);
                  this.$store.commit('sp_Situation0001/setMagazineregisterFlag', true);
                  //make the mail transition link as disable
                  this.sendMailValue = 1;
                  //parameter for api AID0005
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start: this.startDateResult,
                    process_date_end: this.endDateResult,
                    sort_date: '',
                    sort_title:'',
                    Start_num:1,
                    Load_num:10
                  }
                  
                  this.fullscreenLoading = true;
                  //Api call for get the news article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    // this.restrictDateFunction = 0;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.load();
                  }).catch(()=>{
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  })
                
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    Start_num:1,
                    Load_num:10
                  }

                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.webLoad();
                  }).catch(()=>{
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.webLoad();
                  })

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    Start_num:1,
                    Load_num:10
                  }

                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
                    magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.magazineLoad();
                  }).catch(()=>{
                    magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.magazineLoad();
                  })
                })
              }
              else
              {
                //no action needed
              }

            }

            this.startDateResult = startResult;
            this.endDateResult = endResult;

            this.$store.commit("sp_Situation0001/setSearchStartDate", this.startDateResult);
            this.$store.commit("sp_Situation0001/setSearchEndDate", this.endDateResult);
          })
        })
      }
      // 2022/08/02  #12275  START
      if(this.display_today_article_link_flag && this.gettheme.length==0 && this.getthemetopics.length==0 && this.getthemegrouptopics.length==0)
      {
        this.$store.commit('sp_Situation0001/setSearchConditionKey', 0);
        this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", 0);
        this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);

        this.checkedNewsArticle = [];
        this.checkAll = false;
        this.checkedSecondTabNewsArticle = [];
        this.secondTabCheckAll = false;

        this.$store.commit('sp_Situation0001/setArticleTitle', '');
        this.$store.commit('sp_Situation0001/setArticleDate', '');

        this.$store.commit('sp_Situation0001/setWebArticleDate', '');
        this.$store.commit('sp_Situation0001/setWebArticleTitle', '');

        this.$store.commit('sp_Situation0001/setMagazineArticleDate', '');
        this.$store.commit('sp_Situation0001/setMagazineArticleTitle', '');

        var startDate1 = this.range.start;
        var sdate1 = new Date(startDate1),
        smnth1 = ("0" + (sdate1.getMonth() + 1)).slice(-2),
        sday1 = ("0" + sdate1.getDate()).slice(-2);
        var startResult1 = [sdate1.getFullYear(), smnth1, sday1].join("/");
        var endDate1 = this.range.end;
        var edate1 = new Date(endDate1),
        emnth1 = ("0" + (edate1.getMonth() + 1)).slice(-2),
        eday1 = ("0" + edate1.getDate()).slice(-2);
        var endResult1 = [edate1.getFullYear(), emnth1, eday1].join("/");
        this.startDateResult = startResult1;
        this.endDateResult = endResult1;
        this.$store.commit("sp_Situation0001/setSearchStartDate", this.startDateResult);
        this.$store.commit("sp_Situation0001/setSearchEndDate", this.endDateResult);

        this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {
          //2022/08/02  #12275  START
          //this.newsCount = "新聞 (" + 0 + "/" + 0 + "件)";
          //this.webCount = "WEB (0/" + 0 + "件)";
          //this.magazineCount = "雑誌 (0"  + "/" + 0 + "件)";
          this.newsCount = "新聞 (未登録)";
          this.webCount = "WEB (未登録)";
          this.magazineCount = "雑誌 (未登録)";
          this.showbar = false;
          this.NoDefaultNewsData = true;
          this.NoDefaultData = true;
          this.NoDefaultMagazineData = true;
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
          //2022/08/02  #12275  END

          var themeDetails = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: startResult1,
            process_date_end: endResult1
          };

          var existingArticleDetails = [];

          existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId]

          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.$store.dispatch('sp_Communication0001/getTheme', existingArticleDetails).then(() => {
            this.fullscreenLoading = false;
            this.setMailThemeValue = this.getDefaultMailTheme;
            this.selected_theme_name = this.getSelectedLabel;
            //2022/08/02  #12275  START
            //this.setMailThemeId = this.getSelectedTheme[0].id;
            //this.themeValueDate = this.getSelectedTheme[0].value;
            this.setMailThemeId = this.getSelectedTheme.length > 0 ? this.getSelectedTheme[0].id : "";
            this.themeValueDate = this.getSelectedTheme.length > 0 ? this.getSelectedTheme[0].value : "";
            //2022/08/02  #12275  END

            if(this.getIsDefaultDateLoading != 0 && this.restrictDateFunction == 0)
            {
              var inputParam;
              var webinputParam;
              var magazineinputParam;
              var totalNewsLabel;
              var webNewsLabel;
              var magazineLabel;
              if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if date is changed for themes
              {
                //make the mail transition link as clickable
                this.sendMailValue = 0;
                if(this.themeValueDate == "Theme")
                {
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date: this.getArticleDate,
                    sort_title:this.getArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_id:this.setMailThemeId
                  }
                  
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:this.getWebArticleDate,
                    sort_title:this.getWebArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_id:this.setMailThemeId
                  }
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:this.getMagazineArticleDate,
                    sort_title:this.getMagazineArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_id:this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date: this.getArticleDate,
                    sort_title:this.getArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                  
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:this.getWebArticleDate,
                    sort_title:this.getWebArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:this.getMagazineArticleDate,
                    sort_title:this.getMagazineArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                }
                else
                {
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date: this.getArticleDate,
                    sort_title:this.getArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    topics_id:this.setMailThemeId
                  }
                  
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:this.getWebArticleDate,
                    sort_title:this.getWebArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    topics_id:this.setMailThemeId
                  }
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:this.getMagazineArticleDate,
                    sort_title:this.getMagazineArticleTitle,
                    Start_num:1,
                    Load_num:10,
                    topics_id:this.setMailThemeId
                  }
                }

                if(this.getThemeNewsCount != 0)
                {
                  this.fullscreenLoading = true;
                  //Api call for get the news article
                  this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                    this.fullscreenLoading = false;
                    if(this.getScRegisterFlag)
                    {
                      this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                      // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                    }
                    else
                    {
                      this.newsCount = "新聞 (未登録)";
                      // this.newsSecondTabCount = "新聞 (未登録)";
                    }
                    totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.load();
                  }).catch(() => {
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  if(this.getScRegisterFlag)
                  {
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  }
                  else
                  {
                    this.newsCount = "新聞 (未登録)";
                    // this.newsSecondTabCount = "新聞 (未登録)";
                  }
                  totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                  this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                  this.selected_theme_name = this.getSelectedLabel;
                  this.load();
                }

                if(this.getThemeWebCount != 0)
                {
                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
                    this.fullscreenLoading = false;
                    if(this.getWebRegisterFlag)
                    {
                      // 2021/07/07  #11597  START
                      //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                      this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                      // 2021/07/07  #11597  END
                    }
                    else
                    {
                      this.webCount = "WEB (未登録)";
                    }
                    webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                    this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.webLoad();
                  }).catch(() => {
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  if(this.getWebRegisterFlag)
                  {
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                    this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                    // 2021/07/07  #11597  END
                  }
                  else
                  {
                    this.webCount = "WEB (未登録)";
                  }
                  webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                  this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                  this.selected_theme_name = this.getSelectedLabel;
                  this.webLoad();
                }

                if(this.getThemeMagazineCount != 0)
                {
                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
                    this.fullscreenLoading = false;
                    if(this.getMagazineRegisterFlag)
                    {
                      this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                    }
                    else
                    {
                      this.magazineCount = "雑誌 (未登録)";
                    }
                    magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.magazineLoad();
                  }).catch(() => {
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  if(this.getMagazineRegisterFlag)
                  {
                    this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                  }
                  else
                  {
                    this.magazineCount = "雑誌 (未登録)";
                  }
                  magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                  this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                  this.selected_theme_name = this.getSelectedLabel;
                  this.magazineLoad();
                }
              }
              else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if date is changed for today's article link
              {
                this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {

                  this.$store.commit('sp_Situation0001/setScRegisterFlag', true);
                  this.$store.commit('sp_Situation0001/setWebregisterFlag', true);
                  this.$store.commit('sp_Situation0001/setMagazineregisterFlag', true);
                  //make the mail transition link as disable
                  this.sendMailValue = 1;
                  //parameter for api AID0005
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start: this.startDateResult,
                    process_date_end: this.endDateResult,
                    sort_date: '',
                    sort_title:'',
                    Start_num:1,
                    Load_num:10
                  }
                  
                  this.fullscreenLoading = true;
                  //Api call for get the news article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    // this.restrictDateFunction = 0;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.load();
                  }).catch(()=>{
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTodayArticleNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  })
                
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    Start_num:1,
                    Load_num:10
                  }

                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.webLoad();
                  }).catch(()=>{
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTodayArticleNewsCount + "件)";
                    // 2021/07/07  #11597  START
                    //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTodayArticleWebNewsCount + "件)";
                    this.webCount = "WEB (0/" + this.getTodayArticleWebNewsCount + "件)";
                    // 2021/07/07  #11597  END
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.webLoad();
                  })

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    Start_num:1,
                    Load_num:10
                  }

                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
                    magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.magazineLoad();
                  }).catch(()=>{
                    magazineLabel = "雑誌(" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                    this.today_article_label = this.getTodayArticleLabel;
                    this.$store.commit("sp_Situation0001/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("sp_Situation0001/setThemeMagazineCount", this.getTodayArticleMagazineCount);
                    this.selected_theme_name = this.getSelectedLabel;
                    this.magazineCount = "雑誌 (0"+ "/" + this.getTodayArticleMagazineCount + "件)";
                    this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.magazineLoad();
                  })
                })
              }
              else
              {
                //no action needed
              }

            }
          })
        })

      }
      // 2022/08/02  #12275  END
      this.$LogMethodOut("0001","selectDateForSearch");
    },
    GotoThemeMailScreen(){
        this.$LogButtonEvent("0001","EmailTheme");
        this.$LogMethodIN("0001","GotoThemeMailScreen");      
        this.$store.commit("sp_Situation0005/setthemeid0005",this.setMailThemeId );
        this.$store.commit("sp_Situation0005/setthemevalue0005",this.setMailThemeValue );
        this.$store.commit("sp_Situation0005/setdata_kbn", this.data_kbn);
        Vue.prototype.$session.set('themeNewsCountForMobileSorting',this.getThemeNewsCount);
        Vue.prototype.$session.set('themeWebNewsCountForMobileSorting',this.getThemeWebCount);
        Vue.prototype.$session.set('themeMagazineCountForMobileSorting',this.getThemeMagazineCount);
        this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
        if(this.getScRegisterFlag)
        {
          this.$store.commit("sp_Situation0005/setNewsDisabledFlag", false);
        }
        else
        {
          this.$store.commit("sp_Situation0005/setNewsDisabledFlag", true);
        }

        if(this.getWebRegisterFlag)
        {
          this.$store.commit("sp_Situation0005/setWebDisabledFlag", false);
        }
        else
        {
          this.$store.commit("sp_Situation0005/setWebDisabledFlag", true);
        }
        if(this.getMagazineRegisterFlag)
        {
          this.$store.commit("sp_Situation0005/setMagazineDisabledFlag", false);
        }
        else
        {
          this.$store.commit("sp_Situation0005/setMagazineDisabledFlag", true);
        }
        router.push({name:"sp_0005"});
        this.$LogMethodOut("0001","GotoThemeMailScreen");
    },
    sentToNewsSortScreen(){
      this.$LogButtonEvent("0001","SortNewsScreen");
      this.$LogMethodIN("0001","sentToNewsSortScreen");
      this.newsSortCount = 1;
      Vue.prototype.$session.set('themeNewsCountForMobileSorting',this.getThemeNewsCount);
      Vue.prototype.$session.set('themeWebNewsCountForMobileSorting',this.getThemeWebCount);
      Vue.prototype.$session.set('themeMagazineCountForMobileSorting',this.getThemeMagazineCount);
      this.$store.commit('sp_Situation0001/setArticleSortCount', this.getMobNewsArticles.length);
      this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
      this.$store.commit("sp_Situation0001/setSearchStartDate", this.startDateResult);
      this.$store.commit("sp_Situation0001/setSearchEndDate", this.endDateResult);
      console.log(this.getArticleDate);
      console.log(this.getArticleTitle);
      router.push({name:"sp_0003", query: {ActiveTab: this.AllTabs, newsWebCheck: this.newsSortCount, DateValue: this.getArticleDate, TitleValue: this.getArticleTitle}});
      this.$LogMethodOut("0001","sentToNewsSortScreen");
    },
    sentToWebSortScreen(){
      this.$LogButtonEvent("0001","SortWebScreen");
      this.$LogMethodIN("0001","sentToWebSortScreen");
      this.newsSortCount = 2;
      Vue.prototype.$session.set('themeNewsCountForMobileSorting',this.getThemeNewsCount);
      Vue.prototype.$session.set('themeWebNewsCountForMobileSorting',this.getThemeWebCount);
      Vue.prototype.$session.set('themeMagazineCountForMobileSorting',this.getThemeMagazineCount);
      this.$store.commit("sp_Situation0001/setSearchStartDate", this.startDateResult);
      this.$store.commit("sp_Situation0001/setSearchEndDate", this.endDateResult);
      this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
      this.$store.commit('sp_Situation0001/setArticleSortCount', this.getWebArticledetails.length);
      console.log(this.getWebArticleDate);
      console.log(this.getWebArticleTitle);
      router.push({name:"sp_0003", query: {ActiveTab: this.AllTabs, newsWebCheck: this.newsSortCount, DateValue: this.getWebArticleDate, TitleValue: this.getWebArticleTitle}});
      this.$LogMethodOut("0001","sentToWebSortScreen");
    },
    sentToMagazineSortScreen(){
      this.newsSortCount = 5;
      Vue.prototype.$session.set('themeNewsCountForMobileSorting',this.getThemeNewsCount);
      Vue.prototype.$session.set('themeWebNewsCountForMobileSorting',this.getThemeWebCount);
      Vue.prototype.$session.set('themeMagazineCountForMobileSorting',this.getThemeMagazineCount);
      this.$store.commit("sp_Situation0001/setSearchStartDate", this.startDateResult);
      this.$store.commit("sp_Situation0001/setSearchEndDate", this.endDateResult);
      this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
      this.$store.commit('sp_Situation0001/setArticleSortCount', this.getMagazineArticledetails.length);
      router.push({name:"sp_0003", query: {ActiveTab: this.AllTabs, newsWebCheck: this.newsSortCount, DateValue: this.getMagazineArticleDate, TitleValue: this.getMagazineArticleTitle}});
    },
    handleOpen(key, keyPath) {
      this.$LogButtonEvent("0001","OpenNews");
      this.$LogMethodIN("0001","handleOpen");
      console.log(key);
      console.log(keyPath);
      this.$LogMethodOut("0001","handleOpen");
    },
    handleClose(key, keyPath) {
      this.$LogButtonEvent("0001","CloseNews");
      this.$LogMethodIN("0001","handleClose");
      console.log(key);
      console.log(keyPath);
      this.$LogMethodOut("0001","handleClose");
    },
    handleClick(tab, event) {
      this.$LogButtonEvent("0001","TabClick");
      this.$LogMethodIN("0001","handleClick");
      console.log(tab);
      console.log(event);
      this.$LogMethodOut("0001","handleClick");
    },
    handleCheckAllChange(val) {
      this.$LogButtonEvent("0001","CheckAll");
      this.$LogMethodIN("0001","handleCheckAllChange");
      if(val)
      {
        if(this.getMobNewsArticles.length == this.getThemeNewsCount)
        {
          this.checkedNewsArticle = val ? this.getArticlesIds : [];
          defaultValue = this.checkedNewsArticle;
          if(defaultValue.length > 0)
          {
            // 2024/05/15  #17821  START
            var cnt = this.getMobNewsArticles.length;
            var new_checkedNewsArticle= [];
            for(var i=0;i<this.getMobNewsArticles.length;i++){
              if(this.getMobNewsArticles[i].no_image_flag){
                cnt=cnt-1;
              }else{
                new_checkedNewsArticle.push(i+1);
              }
            }
            this.checkedNewsArticle=new_checkedNewsArticle;
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", cnt);
            // 2024/05/15  #17821  END
          }
          else
          {
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
          }
          if(this.getScRegisterFlag)
          {
            this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
          }
          else
          {
            this.newsCount = "新聞(未登録)";
          }
        }
        else
        {
          var themeValue = this.getSelectedTheme[0].value;
          var theme_id = this.getSelectedTheme[0].id;
          var startNumCount = this.getMobNewsArticles.length + 1;
          var loadNumCount = this.getThemeNewsCount - this.getMobNewsArticles.length;
          var inputParam;
          if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
          {
            if(themeValue == "Theme")
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title: this.getArticleTitle,
                Start_num: startNumCount,
                Load_num: loadNumCount,
                theme_id: theme_id
              };
            }
            else if(themeValue == "Theme Group")
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title: this.getArticleTitle,
                Start_num: startNumCount,
                Load_num: loadNumCount,
                theme_group_id: theme_id
              };
            }
            else
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title: this.getArticleTitle,
                Start_num: startNumCount,
                Load_num: loadNumCount,
                topics_id: theme_id
              };
            }

            var existingArticleDetails = [];

            existingArticleDetails = [...existingArticleDetails, inputParam, this.getMobNewsArticles];
            this.fullscreenLoading = true;
            this.$store.dispatch('sp_Communication0001/getNewspaperArticles', existingArticleDetails)
            .then(() => {
              this.fullscreenLoading = false;
              this.checkedNewsArticle = val ? this.getArticlesIds : [];
              defaultValue = this.checkedNewsArticle;
              if(defaultValue.length > 0)
              {
                // 2024/05/15  #17821  START
                var cnt = this.getMobNewsArticles.length;
                var new_checkedNewsArticle= [];
                for(var i=0;i<this.getMobNewsArticles.length;i++){
                  if(this.getMobNewsArticles[i].no_image_flag){
                    cnt=cnt-1;
                  }else{
                    new_checkedNewsArticle.push(i+1);
                  }
                }
                this.checkedNewsArticle=new_checkedNewsArticle;
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", cnt);
                // 2024/05/15  #17821  END
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞(未登録)";
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checkedNewsArticle = val ? this.getArticlesIds : [];
              defaultValue = this.checkedNewsArticle;
              if(defaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞(未登録)";
              }
            });

          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
          {
            
            inputParam = {
              contract_id: this.contractId,
              process_date_start: this.startDateResult,
              process_date_end: this.endDateResult,
              sort_date: this.getArticleDate,
              sort_title: this.getArticleTitle,
              Start_num: startNumCount,
              Load_num: loadNumCount
            };
            

            var existingTodayArticleDetails = [];

            existingTodayArticleDetails = [...existingTodayArticleDetails, inputParam, this.getMobNewsArticles];

            this.fullscreenLoading = true;
            this.$store.dispatch('sp_Communication0001/getNewspaperArticles', existingTodayArticleDetails)
            .then(() => {
              this.fullscreenLoading = false;
              this.checkedNewsArticle = val ? this.getArticlesIds : [];
              defaultValue = this.checkedNewsArticle;
              if(defaultValue.length > 0)
              {
                // 2024/05/15  #17821  START
                var cnt = this.getMobNewsArticles.length;
                var new_checkedNewsArticle= [];
                for(var i=0;i<this.getMobNewsArticles.length;i++){
                  if(this.getMobNewsArticles[i].no_image_flag){
                    cnt=cnt-1;
                  }else{
                    new_checkedNewsArticle.push(i+1);
                  }
                }
                this.checkedNewsArticle=new_checkedNewsArticle;
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", cnt);
                // 2024/05/15  #17821  END
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞(未登録)";
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checkedNewsArticle = val ? this.getArticlesIds : [];
              defaultValue = this.checkedNewsArticle;
              if(defaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞(未登録)";
              }
            });
          }
          else if(this.getSearchConditionKey == 1)
          {
            if(this.getSearchValue != '')//if value is selected from search dropdown
            {
              inputParam = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 1,
                display_id: 'SID0002',
                process_date_from: this.getSearchStartDate,
                process_date_to: this.getSearchEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getArticleDate,
                search_title: this.getSearchValue,
                start_num: startNumCount,
                load_num: loadNumCount,
                sort_title: this.getArticleTitle
                  
              }
            }
            else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getArticleDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_title: this.getArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  user_id: this.userId,
                  key_word: this.getKeywordValue,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else//if keyword textbox is equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getArticleDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_title: this.getArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  user_id: this.userId,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }

            var existingSearchArticleDetails = [];

            existingSearchArticleDetails = [...existingSearchArticleDetails, inputParam, this.getMobNewsArticles];
            
            this.fullscreenLoading = true;
            this.$store.dispatch('sp_Communication0001/getNewsArticleUsingSorting', existingSearchArticleDetails)
            .then(() => {
              this.fullscreenLoading = false;
              this.checkedNewsArticle = val ? this.getArticlesIds : [];
              defaultValue = this.checkedNewsArticle;
              if(defaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              // if(this.getScRegisterFlag)
              // {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              // }
              // else
              // {
                // this.newsCount = "新聞(未登録)";
              // }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checkedNewsArticle = val ? this.getArticlesIds : [];
              defaultValue = this.checkedNewsArticle;
              if(defaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
              }
              // if(this.getScRegisterFlag)
              // {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              // }
              // else
              // {
                // this.newsCount = "新聞(未登録)";
              // }
            });
          }
          else
          {
            //no action needed
          }
        }
      }
      else
      {
        this.checkedNewsArticle = val ? this.getArticlesIds : [];
        defaultValue = this.checkedNewsArticle;
        if(defaultValue.length > 0)
        {
          this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
        }
        else
        {
          this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
        }
        if(this.getScRegisterFlag)
        {
          this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
        }
        else
        {
          this.newsCount = "新聞(未登録)";
        }
      }
      this.$LogMethodOut("0001","handleCheckAllChange");
    },

    handleSecondTabCheckAllChange(val) {
      this.$LogButtonEvent("0001","SecondCheckAll");
      this.$LogMethodIN("0001","handleSecondTabCheckAllChange");
      if(val)
      {
        if(this.getMobNewsArticles.length == this.getThemeNewsCount)
        {
          this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
          secondTabDefaultValue = this.checkedSecondTabNewsArticle;
          defaultValue = secondTabDefaultValue;
          if(secondTabDefaultValue.length > 0)
          {
            this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
          }
          else
          {
            this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
          }
          if(this.getScRegisterFlag)
          {
            // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
          }
          else
          {
            // this.newsSecondTabCount = "新聞(未登録)";
          }
        }
        else
        {
          var themeValue = this.getSelectedTheme[0].value;
          var theme_id = this.getSelectedTheme[0].id;
          var startNumCount = this.getMobNewsArticles.length + 1;
          var loadNumCount = this.getThemeNewsCount - this.getMobNewsArticles.length;
          var inputParam;
          if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
          {
            if(themeValue == "Theme")
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title: this.getArticleTitle,
                Start_num: startNumCount,
                Load_num: loadNumCount,
                theme_id: theme_id
              };
            }
            else if(themeValue == "Theme Group")
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title: this.getArticleTitle,
                Start_num: startNumCount,
                Load_num: loadNumCount,
                theme_group_id: theme_id
              };
            }
            else
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title: this.getArticleTitle,
                Start_num: startNumCount,
                Load_num: loadNumCount,
                topics_id: theme_id
              };
            }

            var existingArticleDetails = [];

            existingArticleDetails = [...existingArticleDetails, inputParam, this.getMobNewsArticles];
            
            this.fullscreenLoading = true;
            this.$store.dispatch('sp_Communication0001/getNewspaperArticles', existingArticleDetails)
            .then(() => {
              this.fullscreenLoading = false;
              this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
              secondTabDefaultValue = this.checkedSecondTabNewsArticle;
              defaultValue = secondTabDefaultValue;
              if(secondTabDefaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                // this.newsSecondTabCount = "新聞(未登録)";
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
              secondTabDefaultValue = this.checkedSecondTabNewsArticle;
              defaultValue = secondTabDefaultValue;
              if(secondTabDefaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                // this.newsSecondTabCount = "新聞(未登録)";
              }
            });

          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
          {
            
            inputParam = {
              contract_id: this.contractId,
              process_date_start: this.startDateResult,
              process_date_end: this.endDateResult,
              sort_date: this.getArticleDate,
              sort_title: this.getArticleTitle,
              Start_num: startNumCount,
              Load_num: loadNumCount
            };
            

            var existingTodayArticleDetails = [];

            existingTodayArticleDetails = [...existingTodayArticleDetails, inputParam, this.getMobNewsArticles];
            
            this.fullscreenLoading = true;
            this.$store.dispatch('sp_Communication0001/getNewspaperArticles', existingTodayArticleDetails)
            .then(() => {
              this.fullscreenLoading = false;
              this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
              secondTabDefaultValue = this.checkedSecondTabNewsArticle;
              defaultValue = secondTabDefaultValue;
              if(secondTabDefaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                // this.newsSecondTabCount = "新聞(未登録)";
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
              secondTabDefaultValue = this.checkedSecondTabNewsArticle;
              defaultValue = secondTabDefaultValue;
              if(secondTabDefaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                // this.newsSecondTabCount = "新聞(未登録)";
              }
            });
          }
          else if(this.getSearchConditionKey == 1)
          {
            if(this.getSearchValue != '')//if value is selected from search dropdown
            {
              inputParam = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 1,
                display_id: 'SID0002',
                process_date_from: this.getSearchStartDate,
                process_date_to: this.getSearchEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getArticleDate,
                search_title: this.getSearchValue,
                start_num: startNumCount,
                load_num: loadNumCount,
                sort_title: this.getArticleTitle
                  
              }
            }
            else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getArticleDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_title: this.getArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  user_id: this.userId,
                  key_word: this.getKeywordValue,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else//if keyword textbox is equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getArticleDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_title: this.getArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                inputParam = {
                  contract_id: this.contractId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  user_id: this.userId,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: startNumCount,
                  load_num: loadNumCount,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }

            var existingSearchArticleDetails = [];

            existingSearchArticleDetails = [...existingSearchArticleDetails, inputParam, this.getMobNewsArticles];

            this.fullscreenLoading = true;
            this.$store.dispatch('sp_Communication0001/getNewsArticleUsingSorting', existingSearchArticleDetails)
            .then(() => {
              this.fullscreenLoading = false;
              this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
              secondTabDefaultValue = this.checkedSecondTabNewsArticle;
              defaultValue = secondTabDefaultValue;
              if(secondTabDefaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                // this.newsSecondTabCount = "新聞(未登録)";
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
              secondTabDefaultValue = this.checkedSecondTabNewsArticle;
              defaultValue = secondTabDefaultValue;
              if(secondTabDefaultValue.length > 0)
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              else
              {
                this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
              }
              if(this.getScRegisterFlag)
              {
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                // this.newsSecondTabCount = "新聞(未登録)";
              }
            });
          }
          else
          {
            //no action needed
          }
        }
      }
      else
      {
        this.checkedSecondTabNewsArticle = val ? this.getArticlesIds : [];
        secondTabDefaultValue = this.checkedSecondTabNewsArticle;
        defaultValue = secondTabDefaultValue;
        if(secondTabDefaultValue.length > 0)
        {
          this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
        }
        else
        {
          this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
        }
        if(this.getScRegisterFlag)
        {
          // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
        }
        else
        {
          // this.newsSecondTabCount = "新聞(未登録)"
        }
      }
      this.$LogMethodOut("0001","handleSecondTabCheckAllChange");
    },
    handleCheckAllChangeWeb(val) {
      this.checkedWebArticle = val ? this.getArticlesIds__Web : [];
    },
    handleCheckAllChangeMagazine(val) {
      this.checkedMagazineArticle = val ? this.getArticlesIds__Magazine : [];
    },
    handleCheckedMagazineArticleChange(value) {
      let checkedCount = value.length;
      this.checkAllMagazine = checkedCount === this.getMagazineArticledetails.length;
    },
    handleCheckedNewsArticleChange(value) {
      this.$LogButtonEvent("0001","CheckNewsArticle");
      this.$LogMethodIN("0001","handleCheckedNewsArticleChange");      
      let checkedCount = value.length;

      // 2024/05/17  #17820  START
      let checkAll_flag = false;
      let checkAll_old = this.checkAll;
      for(var i=0;i<this.checkedNewsArticle.length;i++){
        if(i==this.checkedNewsArticle.length-1){
          for(var j=0;j<this.getMobNewsArticles.length;j++){
            if(this.checkedNewsArticle[i] == this.getMobNewsArticles[j].article_no){
              if(this.getMobNewsArticles[j].no_image_flag){
                this.checkedNewsArticle.pop();
                checkAll_flag = true;
              }
            }
          }
        }
      }
      this.checkAll = checkedCount === this.getMobNewsArticles.length;
      if(checkAll_flag){
        this.checkAll = checkAll_old;
      }
      // 2024/05/17  #17820  END
      defaultValue = value;
      if(defaultValue.length > 0)
      {
        this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
      }
      else
      {
        this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", defaultValue.length);
      }
      if(this.getScRegisterFlag)
      {
        this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
      }
      else
      {
        this.newsCount = "新聞(未登録)"
      }
      this.$LogMethodOut("0001","handleCheckedNewsArticleChange");
    },
    handleCheckedSecondTabNewsArticleChange(value) {
      this.$LogButtonEvent("0001","CheckSecondNews");
      this.$LogMethodIN("0001","SecondTabNewsArticleChange");   
      let secondTabCheckedCount = value.length;
      this.secondTabCheckAll = secondTabCheckedCount === this.getMobNewsArticles.length;
      secondTabDefaultValue = value;
      defaultValue = value;
      if(secondTabDefaultValue.length > 0)
      {
        this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
      }
      else
      {
        this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", secondTabDefaultValue.length);
      }
      if(this.getScRegisterFlag)
      {
        // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
      }
      else
      {
        // this.newsSecondTabCount = "新聞(未登録)"
      }
      this.$LogMethodOut("0001","SecondTabNewsArticleChange");
    },
    sendToErrorDisplay(m_article){
      this.$LogButtonEvent("0001","PdfFormat");
      this.$LogMethodIN("0001","sendToErrorDisplay");
      // 2022/02/14  #12197  START
      if(this.repeat){
        return
      }
      this.repeat = true;
      // 2022/02/14  #12197  END
      var pdfValues = {
        pdf_flag:1,
        article_info:[
          {
            article_id: m_article.article_id,
            data_section: m_article.data_section
          }
        ],
        user_id:this.userId,
        contract_code:this.contract_code,
        theme_browsing:this.theme_browsing,
        display_id:"SID0002",
        is_mail:false,
      };

      var pdfSuccessValues = {
        data_info:[{
        contract_id: this.contractId,
        data_section: m_article.data_section,
        user_id: this.userId,
        request_div:1,
        article_id: m_article.article_id,
        session_id: this.session_id,
        user_group_name: this.user_group_name,
        theme_id: this.getThemeIdForPdfSuccess,
        theme_group_id: this.getThemeGroupIdForPdfSuccess,
        topics_id: this.getTopicsIdForPdfSuccess
        }]
      }

      var pdfCombinedArray = [];

      pdfCombinedArray = [...pdfCombinedArray, pdfValues, pdfSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        // 2023/03/27  #14161  START
				var lock = false;
				// 2023/03/27  #14161  END
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              // 2023/03/27  #14161  START
              if(lock){
                return
              }
              lock = true;
              // 2023/03/27  #14161  END
              if(action === "confirm"){
                /*******BT08460_EXTERNAL-1788 issue fix*******/
                this.$session.set('pdfCombinedArray', pdfCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                // 2022/02/14  #12197  START
                setTimeout(() => {
                        this.repeat = false;
                    }, 60);
                // 2022/02/14  #12197  END
                
                /*******BT08460_EXTERNAL-1788 issue fix*******/
                done();
              }else{
                // 2022/02/14  #12197  START
                this.repeat = false;
                // 2022/02/14  #12197  END
                done();
              }
            }
          }
        );
      }
      else
      {
        /*******BT08460_EXTERNAL-1788 issue fix*******/
        this.$session.set('pdfCombinedArray', pdfCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        // 2022/02/14  #12197  START
        setTimeout(() => {
                this.repeat = false;
            }, 60);
        // 2022/02/14  #12197  END
        /*this.fullscreenLoading = true;
        this.$store.dispatch('sp_Communication0004/checkPdfDisplay', pdfCombinedArray).then(() => {
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false
        })*/
        /*******BT08460_EXTERNAL-1788 issue fix*******/
      }
      this.$LogMethodOut("0001","sendToErrorDisplay");
    },
    handleCheckedWebArticleChange(value) {
      this.$LogButtonEvent("0001","CheckWebArticle");
      this.$LogMethodIN("0001","handleCheckedWebArticleChange");    
      let checkedCount = value.length;
      this.checkAllWeb = checkedCount === this.getWebArticledetails.length;
      this.$LogMethodOut("0001","handleCheckedWebArticleChange");
    },
    getPdfPrintScreen(m_article){
      this.$LogButtonEvent("0001","PdfPrintScreen");
      this.$LogMethodIN("0001","getPdfPrintScreen");

      // 2023/03/27  #14161  START
      if(this.repeat1){
        return
      }
      this.repeat1 = true;
      // 2023/03/27  #14161  END

      var articleDetails = {};

      if(m_article.data_section == 1)
      {
        articleDetails = {
          articleId: m_article.article_id,
          data_section: m_article.data_section,
          articleTitle: m_article.article_title,
          articleCategory: m_article.media_name,
          articleDate: m_article.issue_date,
          articlePages: m_article.articleEdition,
          frame_no: m_article.frame_no,
          head_no: m_article.head_no,
          trace: m_article.trace,
          note: m_article.note,
          articleImagecount: m_article.image_count,
          articleComment: m_article.article_comment,
          is_mail:false
        };
      }
      else if(m_article.data_section == 2)
      {
        articleDetails = {
          articleId: m_article.article_id,
          data_section: m_article.data_section,
          articleTitle: m_article.article_title,
          articleCategory: m_article.media_name,
          articleDate: m_article.issue_date,
          articlePages: m_article.articleEdition,
          frame_no: m_article.frame_no,
          articleCharcount: m_article.char_count,
          articleComment: m_article.article_comment,
          is_mail:false
        };
      }
      else
      {
        //No Action Needed
      }
      // 2021/12/7  #12178  START
      //if(this.getOut_Demand_Confirm_Message_Div_Flag)
      if(this.getOut_Demand_Confirm_Message_Div_Flag && m_article.data_section == 1)
      // 2021/12/7  #12178  END
      {
        // 2023/03/27  #14161  START
				var lock = false;
				// 2023/03/27  #14161  END
        this.$confirm(this.getDemandConfirmTextMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            // 2023/03/27  #14161  START
            if(lock){
              return
            }
            lock = true;
            // 2023/03/27  #14161  END
            if(action === "confirm"){
              let routeData = this.$router.resolve({name: 'sp_0008', query: articleDetails}); 
              window.open(routeData.href, '_blank');
              // 2023/03/27  #14161  START
              setTimeout(() => {
                      this.repeat1 = false;
                  }, 60);
              // 2023/03/27  #14161  END
              done();
            }else{
              // 2023/03/27  #14161  START
              this.repeat1 = false;
              // 2023/03/27  #14161  END
              done();
            }
          }
        });
      }
      else
      {
        // 2023/03/27  #14161  START
        setTimeout(() => {
                this.repeat1 = false;
            }, 60);
        // 2023/03/27  #14161  END
        let routeData = this.$router.resolve({name: 'sp_0008', query: articleDetails}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("0001","getPdfPrintScreen");
    },
    sendtopdfdisplay(){
      this.$LogButtonEvent("0001","PdfBatchDisplay");
      this.$LogMethodIN("0001","sendtopdfdisplay");   
      var article_details = [];
      var pdfCompletionArray = [];
      // var McArticle = JSON.parse(this.$session.get('MC'));
      // var ScArticle = JSON.parse(this.$session.get('SC'));
      var newsArticle = this.getMobNewsArticles;
      console.log(newsArticle)
      if(defaultValue.length > 0)
      {
        if(defaultValue.length <= this.collective_demand_max_count)
        {
          // for(var i=0;i<defaultValue.length;i++)
          // {
          //   for(var j=0;j<newsArticle.length;j++)
          //   {
          //     if(newsArticle[j].article_no == defaultValue[i])
          //     {
          //       article_details = [...article_details, {article_id: newsArticle[j].article_id, data_section: newsArticle[j].data_section}];
          //       pdfCompletionArray = [...pdfCompletionArray, {contract_id: this.contractId, data_section: newsArticle[j].data_section, user_id: this.userId, request_div: 1, article_id: newsArticle[j].article_id, session_id: this.session_id, user_group_name: this.user_group_name, theme_id: this.getThemeIdForPdfSuccess, theme_group_id: this.getThemeGroupIdForPdfSuccess, topics_id: this.getTopicsIdForPdfSuccess}];
          //     }
          //   }
          // }
          //Modified for BT08460_EXTERNAL-1784
          for(var i=0;i<newsArticle.length;i++)
          {
            for(var j=0;j<defaultValue.length;j++)
            {
              if(newsArticle[i].article_no == defaultValue[j])
              {
                // 2024/05/15  #17821  START
                if(!newsArticle[i].no_image_flag){
                    article_details.push({
                    article_id: newsArticle[i].article_id,
                    data_section: newsArticle[i].data_section});
                    
		    pdfCompletionArray.push({
                      contract_id: this.contractId, 
                      data_section: newsArticle[i].data_section, 
                      user_id: this.userId, 
                      request_div: 1, 
                      article_id: newsArticle[i].article_id, 
                      session_id: this.session_id, 
                      user_group_name: this.user_group_name, 
                      theme_id: this.getThemeIdForPdfSuccess, 
                      theme_group_id: this.getThemeGroupIdForPdfSuccess, 
                      topics_id: this.getTopicsIdForPdfSuccess
                    });
                  }
                // 2024/05/15  #17821  END
              }
            }
          }
          var pdfValues = {
            pdf_flag:1,
            article_info:article_details,
            user_id:this.userId,
            contract_code:this.contract_code,
            theme_browsing:this.theme_browsing,
            display_id:"SID0002",
            is_mail:false,
          };
          var pdfSuccessValues = {
            data_info: pdfCompletionArray
          }

          var pdfCombinedArray = [];

          pdfCombinedArray = [...pdfCombinedArray, pdfValues, pdfSuccessValues];

          if(this.getOut_Demand_Confirm_Message_Div_Flag)
          {
            this.$confirm(
              this.getDemandConfirmPdfMessage,
              "確認",
              {
                confirmButtonText: "OK",
                cancelButtonText: "キャンセル"
              }
            ).then(() => {
              if(defaultValue.length >= this.display_delay_message_min && defaultValue.length <= this.collective_demand_max_count)
              {
                this.$confirm(
                  "表示件数が多いため表示処理に時間がかかりますがよろしいでしょうか？",
                  "確認",
                  {
                    confirmButtonText: "OK",
                    cancelButtonText: "キャンセル"
                  }
                ).then(() => {
                  /*******BT08460_EXTERNAL-1788 issue fix*******/
                  this.$session.set('pdfCombinedArray', pdfCombinedArray);
                  let routeData = this.$router.resolve({name: '0001-001'}); 
                  window.open(routeData.href, '_blank');
                  /*this.fullscreenLoading = true;
                  this.$store.dispatch('sp_Communication0004/checkPdfDisplay', pdfCombinedArray).then(() => {
                    this.fullscreenLoading = false;
                  }).catch(() => {
                    this.fullscreenLoading = false
                  })*/
                  /*******BT08460_EXTERNAL-1788 issue fix*******/
                })
              }
              else
              {
                /*******BT08460_EXTERNAL-1788 issue fix*******/
                this.$session.set('pdfCombinedArray', pdfCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                /*this.fullscreenLoading = true;
                this.$store.dispatch('sp_Communication0004/checkPdfDisplay', pdfCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                }).catch(() => {
                  this.fullscreenLoading = false
                })*/
                /*******BT08460_EXTERNAL-1788 issue fix*******/
              }
            });
          }
          else
          {
            // 2021/01/11 #10236 START
            if(defaultValue.length >= this.display_delay_message_min && defaultValue.length <= this.collective_demand_max_count)
            {
              this.$confirm(
                "表示件数が多いため表示処理に時間がかかりますがよろしいでしょうか？",
                "確認",
                {
                  confirmButtonText: "OK",
                  cancelButtonText: "キャンセル"
                }
              ).then(() => {
                this.$session.set('pdfCombinedArray', pdfCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
              })
            }
            else
            {
            // 2021/01/11 #10236 END
            /*******BT08460_EXTERNAL-1788 issue fix*******/
            this.$session.set('pdfCombinedArray', pdfCombinedArray);
            let routeData = this.$router.resolve({name: '0001-001'}); 
            window.open(routeData.href, '_blank');
            /*this.fullscreenLoading = true;
            this.$store.dispatch('sp_Communication0004/checkPdfDisplay', pdfCombinedArray).then(() => {
              this.fullscreenLoading = false;
            }).catch(() => {
              this.fullscreenLoading = false
            })*/
            /*******BT08460_EXTERNAL-1788 issue fix*******/
            // 2021/01/11 #10236 START
            }
            // 2021/01/11 #10236 END
          }
          // if(this.print_confirm_dialog_flag != 0)
          // {
          //   this.$confirm("PDF表示処理は規定の料金が課金されます。処理を続行しますか？","確認",
          //   {
          //     showCancelButton: true,
          //     confirmButtonText: "OK",
          //     cancelButtonText: "キャンセル",
          //     beforeClose: (action, instance, done) => {
          //       if(action === "confirm"){
          //         this.fullscreenLoading = true;
          //         this.$store.dispatch('sp_Communication0004/checkPdfDisplay', pdfCombinedArray).then(() => {
          //           this.fullscreenLoading = false;
          //         }).catch(() => {
          //           this.fullscreenLoading = false;
          //         })
          //         done();
          //       }else{
          //         done();
          //       }
          //     }
          //   });
          // }
          // else
          // {
          //   this.fullscreenLoading = true;
          //   this.$store.dispatch('sp_Communication0004/checkPdfDisplay', pdfCombinedArray).then(() => {
          //     this.fullscreenLoading = false;
          //   }).catch(() => {
          //     this.fullscreenLoading = false;
          //   })
          // }
        }
        else
        {
          this.$alert("1回に表示できる記事の上限値を超えています。","確認", {
              confirmButtonText: 'OK',
          })
        }
      }
      else
      {
        this.$confirm(
            json["1023_delete_confirm_message"],
            "確認",
            {
              showCancelButton: false,
              confirmButtonText: "OK"
            }
          );
      }
      this.$LogMethodOut("0001","sendtopdfdisplay");
    },
    // 2025/12/23 生成AIサービス連携 START
    handleAiButtonClick() {
      this.fullscreenLoading = true;
      this.$LogButtonEvent("0001", "AiServiceButton");
      this.$LogMethodIN("0001", "handleAiButtonClick");

      // Call backend to generate fresh JWT token
      const newWin = window.open('', '_blank');
      this.$store.dispatch('communication0001/getAiToken')
          .then(() => {
             setTimeout(() => {
              // 2026/06/15  生成AI連携商用版対応  START
              //if (newWin) newWin.location.href = Common.AI_SERVICE_URL;
              if (newWin) newWin.location.href = this.$store.getters['situation0001/getAiServiceUrl'];
              // 2026/06/15  生成AI連携商用版対応  END
              this.fullscreenLoading = false;
              this.$LogMethodOut("0001", "handleAiButtonClick");
            }, 1000);
          })
          .catch((error) => {
            console.error('Failed to get JWT token:', error);
            this.fullscreenLoading = false;
            if (newWin) newWin.close();
            this.$LogMethodOut("0001", "handleAiButtonClick");
          });
    },
    // 2025/12/23 生成AIサービス連携 END
  },
  computed: {
    ...mapGetters("sp_Situation0001", ["getMobNewsArticles", 
                                      "getMobWebArticles",
                                      "getTotalNewsCount", 
                                      "getArticleDate",
                                      "getArticleTitle",
                                      "getWebArticledetails",
                                      "getWebTotalNewsCount",
                                      "getMagazineArticledetails",
                                      "getMagazineTotalNewsCount",
                                      "getTotalNewsLabel",
                                      "getActiveTabs",
                                      "getSearchValue",
                                      "getKeywordValue",
                                      "getMediaValue",
                                      "getSearchStartDate",
                                      "getSearchEndDate",
                                      "getSearchConditionKey",
                                      "getSelectedTheme",
                                      "getDefaultMailTheme",
                                      "getAdminUserAlertNotice",
                                      "getUserNotice",
                                      "getNewsFirstTabCheckboxValue",
                                      "getWebTotalLabel",
                                      "getMagazineTotalLabel",
                                      "getMcArticleAvailableDate",
                                      "getScArticleAvailableDate",
                                      "getWebArticleAvailableDate",
                                      "getMagazineArticleAvailableDate",
                                      "getSortedElArticleDate",
                                      "getNewswebCheck",
                                      "gettheme",
                                      "getthemetopics",
                                      "getthemegrouptopics",
                                      "getThemeNewsCount",
                                      "getThemeWebCount",
                                      "getThemeMagazineCount",
                                      "getThemeLoadCheck",
                                      "getIsTopPageInitialLoading",
                                      "getMaxArticleCountPerPage",
                                      "getArticleSortCount",
                                      "getIsDefaultDateLoading",
                                      "getSelectedLabel",
                                      "getNewsSecondTabCheckboxValue",
                                      "getScRegisterFlag",
                                      "getWebRegisterFlag",
                                      "getMagazineRegisterFlag",
                                      "getThemeIdForPdfSuccess",
                                      "getThemeGroupIdForPdfSuccess",
                                      "getTopicsIdForPdfSuccess",
                                      "getPopUpBlockerFlag",
                                      "getTodayArticleLabel",
                                      "getTodayArticleNewsCount",
                                      "getTodayArticleWebNewsCount",
                                      "getTodayArticleMagazineCount",
                                      "getTodayArticleFlag",
                                      "getloadFromMailFlag",
                                      "getloadFromMailDate",
                                      "getloadFromMailTheme",
                                      "getTabCheckFlagForSorting",
                                      "getWebArticleDate",
                                      "getWebArticleTitle",
                                      "getMagazineArticleDate",
                                      "getMagazineArticleTitle"]),
    ...mapGetters("situation0001", ["getUserId",
                                    "getContractId",
                                    "getThemeBrowsing",
                                    "getContractCode",
                                    "getUserGroupName",
                                    "getMessageInfo",
                                    "getMC_Pdf_View_Flag",
                                    "getMC_Pdf_Print_Flag",
                                    "getMC_Text_View_Flag",
                                    "getMC_Text_Print_Flag",
                                    "getSC_Pdf_View_Flag",
                                    "getSC_Pdf_Print_Flag",
                                    "getSC_Text_View_Flag",
                                    "getSC_Text_Print_Flag",
                                    "getDefault_Font_Size",
                                    "getNews_Article_Flag",
                                    "getDefault_Font_Size",
                                    "getWeb_News_Article_Flag",
                                    "getMagazine_Article_Flag",
                                    "getUserGroup_News_Article_Flag",
                                    "getUserGroup_Web_News_Article_Flag",
                                    "getUserGroup_Magazine_Article_Flag",
                                    // 2025/12/23 生成AIサービス連携 START
                                    "getAiDisplayFlag",
                                    // 2025/12/23 生成AIサービス連携 END
                                    "getCompanyConfigurationInfo",
                                    "getOut_Demand_Confirm_Message_Div_Flag",
                                    "getDemandConfirmPdfMessage",
                                    "getDemandConfirmTextMessage",
                                    "getServiceLinkageInfo",
                                    "getPdfUsageDisplayFlag"]),                          
    getArticlesIds: function() {
      var articlesIds = [];
      this.getMobNewsArticles.forEach(function(m_article) {
        articlesIds.push(m_article.article_no);
      });
      return articlesIds;
    },
    getArticlesIds__Web: function() {
      var articlesIds__Web = [];
      this.getWebArticledetails.forEach(function(article) {
        articlesIds__Web.push(article.articleId);
      });
      return articlesIds__Web;
    },
    getArticlesIds__Magazine: function() {
      var articlesIds__Magazine = [];
      this.getMagazineArticledetails.forEach(function(article) {
        articlesIds__Magazine.push(article.articleId);
      });
      return articlesIds__Magazine;
    },
    // 2026/06/15  生成AI連携商用版対応  START
    ai_link_flag() {
      return this.getAiDisplayFlag;
    },
    // 2026/06/15  生成AI連携商用版対応  END
  },
  mounted() { 

    /**Page Load from Mail */
    var is_loadFromMail = this.getloadFromMailFlag;
    console.log(is_loadFromMail);
    
    /**Page Load from Mail */

    //get the external DB link based on the url
    this.externalDbUrl = Common.General.SetExternalDBUrlLink();

    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    //get the contract_code value from session
    this.contract_code = this.getContractCode;

    //get the session id value from session
    this.session_id = Vue.prototype.$session.get('session-id');

    //get the user_group_name value from session
    this.user_group_name = this.getUserGroupName;

    //get the pdf_usage_display_flag from session
    this.pdf_usage_display_flag = this.getPdfUsageDisplayFlag;

    this.mc_pdf_view_flag = this.getMC_Pdf_View_Flag;
    this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag;
    this.mc_text_view_flag = this.getMC_Text_View_Flag;
    this.mc_text_print_flag = this.getMC_Text_Print_Flag;

    this.sc_pdf_view_flag = this.getSC_Pdf_View_Flag;
    this.sc_pdf_print_flag = this.getSC_Pdf_Print_Flag;
    this.sc_text_view_flag = this.getSC_Text_View_Flag;
    this.sc_text_print_flag = this.getSC_Text_Print_Flag;

    //get the news_article_flag from the session
    this.news_article_flag = this.getNews_Article_Flag;
    //get the web_news_article_flag from the session
    this.web_news_article_flag = this.getWeb_News_Article_Flag;

    //get the user_group_news_article_flag from the session
    this.user_group_news_article_flag = this.getUserGroup_News_Article_Flag;
    //get the user_group_web_news_article_flag from the session
    this.user_group_web_news_article_flag = this.getUserGroup_Web_News_Article_Flag;

    // 2026/06/15  生成AI連携商用版対応  START
    //// 2025/12/23 生成AIサービス連携 START
    //this.ai_link_flag = this.getAiDisplayFlag;
    //// 2025/12/23 生成AIサービス連携 END
    // 2026/06/15  生成AI連携商用版対応  END

    if(this.news_article_flag && this.user_group_news_article_flag)
    {
      this.tabs.push('news');
    }
    if(this.getMagazine_Article_Flag && this.getUserGroup_Magazine_Article_Flag)
    {
      this.tabs.push('magazine');
    }
    if(this.web_news_article_flag && this.user_group_web_news_article_flag)
    {
      this.tabs.push('web');
    }

    if(this.tabs.length>=2)
    {
      this.$store.commit("sp_Situation0001/setActiveTabs", "first");
    }
    else if(this.news_article_flag && this.user_group_news_article_flag)
    {
      this.$store.commit("sp_Situation0001/setActiveTabs", "second");
    }
    else if(this.getMagazine_Article_Flag && this.getUserGroup_Magazine_Article_Flag)
    {
      this.$store.commit("sp_Situation0001/setActiveTabs", "fourth");
    }
    else if(this.web_news_article_flag && this.user_group_web_news_article_flag)
    {
      this.$store.commit("sp_Situation0001/setActiveTabs", "third");
    }

    //get the service linkage info value from the session
    var service_linkage = this.getServiceLinkageInfo;

    for(var l=0;l<service_linkage.length;l++)
    {
      if(service_linkage[l].data_section == 4)
      {
        this.external_link_flag = true;
      }
      else
      {
        //no action needed
        // 2024/05/15  #17821  START
        if(service_linkage[l].data_section == 1)
        {
          this.csv_download_flag = service_linkage[l].csv_output_flag;
        }
        // 2024/05/15  #17821  END
      }
    }

    //get the service linkage info value from the session
    var company_configuration_info = this.getCompanyConfigurationInfo

    for(var s=0;s<company_configuration_info.length;s++)
    {
      if(company_configuration_info[s].configuration_key == "DELAY_MESSAGE_MAX")
      {
        this.collective_demand_max_count = company_configuration_info[s].configuration_value;
      }
      else if(company_configuration_info[s].configuration_key == "DELAY_MESSAGE_MIN")
      {
        this.display_delay_message_min = company_configuration_info[s].configuration_value;
      }
      else if(company_configuration_info[s].configuration_key == "DISP_THEME_MAIL_LINK")
      {
        this.display_theme_mail_link_flag = company_configuration_info[s].configuration_value
      }
      else if(company_configuration_info[s].configuration_key == "DISP_TODAY_ARTICLE_LINK")
      {
        this.display_today_article_link_flag = company_configuration_info[s].configuration_value
        if(this.display_today_article_link_flag == "1")
        {
          this.display_today_article_link_flag = true;
          // this.$store.commit('sp_Situation0001/setTodayArticleFlag', true);
        }
        else
        {
          this.display_today_article_link_flag = false
          // this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);
        }
      }
      else
      {
        //no action needed
      }
    }

    //Api call for get the el admin notice
    this.$store.dispatch('sp_Communication0001/getAdminUserNotice').then(() => {
      this.adminNotice = this.getAdminUserAlertNotice
      if(this.adminNotice != '' && this.adminNotice != null){
        this.isNoticeExist = true
      }
    })

    this.$store.dispatch('sp_Communication0001/getUserNotice').then(() => {
      this.userNotice = this.getUserNotice
      if(this.userNotice != ''){
        this.showNotification = true
      }
    })

    this.$store.dispatch('sp_Communication0001/getArticleAvailableDate').then(() => {
      this.attributes[0].dates = this.getMcArticleAvailableDate
      this.attributes[1].dates = this.getScArticleAvailableDate
      this.attributes[2].dates = this.getWebArticleAvailableDate
      this.attributes[3].dates = this.getMagazineArticleAvailableDate;
      if(this.getThemeLoadCheck == 0)
      {

        this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {
          var latestNewsDate = this.getSortedElArticleDate[this.getSortedElArticleDate.length - 1]

          var sdate = new Date(latestNewsDate),
          smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
          sday = ("0" + sdate.getDate()).slice(-2);
          //convert the date format
          this.startDateResult = [sdate.getFullYear(), smnth, sday].join("/");

          this.range = {
            start: new Date(this.startDateResult),
            end: new Date(this.startDateResult)
          }

          this.$store.commit("sp_Situation0001/setSearchStartDate", this.startDateResult);
          this.$store.commit("sp_Situation0001/setSearchEndDate", this.startDateResult);
          
          this.endDateResult = this.startDateResult;

          this.AllTabs = this.getActiveTabs;
          var themeDetails = {
            contract_id:this.contractId,
            theme_browsing:this.theme_browsing,
            user_id:this.userId,
            display_id:"SID0002",
            process_date_start: this.startDateResult,
            process_date_end: this.endDateResult
          };

          this.fullscreenLoading = true;
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
          this.$store.dispatch('sp_Communication0001/getTheme', themeDetails).then(() => {
            this.fullscreenLoading = false;
            this.setMailThemeValue = this.getDefaultMailTheme;
            this.selected_theme_name = this.getSelectedLabel;
            this.setMailThemeId = this.getSelectedTheme[0].id;
            this.themeValueDate = this.getSelectedTheme[0].value;
            Vue.prototype.$session.set('themeLabelAfterLogin',this.getSelectedLabel);
            Vue.prototype.$session.set('themeValueAfterLogin',this.getSelectedTheme[0].value);
            Vue.prototype.$session.set('themeIdAfterLogin',this.getSelectedTheme[0].id);
            Vue.prototype.$session.set('themeNewsCountAfterLogin',this.getThemeNewsCount);
            Vue.prototype.$session.set('themeWebCountAfetrLogin',this.getThemeWebCount);
            Vue.prototype.$session.set('themeMagazineCountAfetrLogin',this.getThemeMagazineCount);
            this.defaultDateLoading = 1
            this.sendMailValue = 0
            this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
            
            var inputParam;
            var webinputParam;
            var magazineinputParam;
            var totalNewsLabel;
            var webNewsLabel;
            var magazineLabel;
            /*** Change by AJ for backlog Id: 1760 */
            //Remove code for load Today's Articles while page loading
            //then load article based on Topics,Theme Group and Theme
            /*** Change by AJ for backlog Id: 1760 */

            this.restrictArticleSortingDate = 1;
            this.restrictDateFunction = 0;

            this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);

            if(this.themeValueDate == "Theme")
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_id:this.setMailThemeId
              }
              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_id:this.setMailThemeId
              }
              this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', this.setMailThemeId);
              this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);
              
            }
            else if(this.themeValueDate == "Theme Group")
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_group_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_group_id:this.setMailThemeId
              }
              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_group_id:this.setMailThemeId
              }
              this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', this.setMailThemeId);
              this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);
              
            }
            else
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                topics_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                topics_id:this.setMailThemeId
              }
              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                topics_id:this.setMailThemeId
              }
              this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', this.setMailThemeId);
              
            }

            if(this.getThemeNewsCount != 0)
            {
              this.fullscreenLoading = true;
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
              //Api call for get the news article
              this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                }
                else
                {
                  this.newsCount = "新聞 (未登録)";
                  // this.newsSecondTabCount = "新聞 (未登録)";
                }
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
                this.fullscreenLoading = false;
                this.load();
              }).catch(()=>{
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                }
                else
                {
                  this.newsCount = "新聞 (未登録)";
                  // this.newsSecondTabCount = "新聞 (未登録)";
                }
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
                this.fullscreenLoading = false;
                this.load();
              })
            }
            else
            {
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
              this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
              this.load();
            }

            if(this.getThemeWebCount != 0)
            {
              this.fullscreenLoading = true;
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
              //Api call to get web article
              this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
                if(this.getWebRegisterFlag)
                {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
                }
                else
                {
                  this.webCount = "WEB (未登録)";
                }
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
                this.fullscreenLoading = false;
                this.webLoad();
              }).catch(()=>{
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
                if(this.getWebRegisterFlag)
                {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
                }
                else
                {
                  this.webCount = "WEB (未登録)";
                }
                this.fullscreenLoading = false;
                this.webLoad();
              })
            }
            else
            {
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
              this.webLoad();
            }

            if(this.getThemeMagazineCount != 0)
            {
              this.fullscreenLoading = true;
              //Api call to get web article
              this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
                this.fullscreenLoading = false;
                if(this.getMagazineRegisterFlag)
                {
                  this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                }
                else
                {
                  this.magazineCount = "雑誌 (未登録)";
                }
                magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                this.magazineLoad();
              }).catch(() => {
                this.fullscreenLoading = false;
                if(this.getMagazineRegisterFlag)
                {
                  this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                }
                else
                {
                  this.magazineCount = "雑誌 (未登録)";
                }
                magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                this.magazineLoad();
                this.fullscreenLoading = false;
              })
            }
            else
            {
              if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
              this.magazineLoad();
            }

          })
          .catch(() => {
            this.fullscreenLoading = false;
          })
        })
      }
      else if(is_loadFromMail)
      {
        console.log("Inside mail")
        this.$store.commit('sp_Situation0001/setloadFromMailFlag', false, { root: true })
        this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0, { root: true });
        var mail_loadDate = this.getloadFromMailDate
        var mail_theme = this.getloadFromMailTheme
        this.$store.dispatch('sp_Communication0001/resetAllArticleValues').then(() => {
          

          
          this.startDateResult = mail_loadDate;

          this.range = {
            start: new Date(this.startDateResult),
            end: new Date(this.startDateResult)
          }
          console.log(this.startDateResult)
          this.$store.commit("sp_Situation0001/setSearchStartDate", this.startDateResult);
          this.$store.commit("sp_Situation0001/setSearchEndDate", this.startDateResult);
          
          this.endDateResult = this.startDateResult
          
          

          this.AllTabs = this.getActiveTabs
          var mailthemeDetails = {
            contract_id:this.contractId,
            theme_browsing:this.theme_browsing,
            user_id:this.userId,
            display_id:"SID0002",
            process_date_start: this.startDateResult,
            process_date_end: this.endDateResult
          };

          var mailexistingArticleDetails = [];
          this.setMailThemeId = mail_theme[0].id;
          this.themeValueDate = mail_theme[0].value;
          this.$store.commit("sp_Situation0001/setSelectedTheme", mail_theme);
          mailexistingArticleDetails = [...mailexistingArticleDetails, mailthemeDetails, this.themeValueDate, this.setMailThemeId]
          
          this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
          this.$store.dispatch('sp_Communication0001/getTheme', mailexistingArticleDetails).then(() => {
            console.log(this.getSelectedTheme)
            this.setMailThemeValue = this.getDefaultMailTheme
            this.selected_theme_name = this.getSelectedLabel
            this.setMailThemeId = this.getSelectedTheme[0].id
            this.themeValueDate = this.getSelectedTheme[0].value
            Vue.prototype.$session.set('themeLabelAfterLogin',this.getSelectedLabel);
            Vue.prototype.$session.set('themeValueAfterLogin',this.getSelectedTheme[0].value);
            Vue.prototype.$session.set('themeIdAfterLogin',this.getSelectedTheme[0].id);
            Vue.prototype.$session.set('themeNewsCountAfterLogin',this.getThemeNewsCount);
            Vue.prototype.$session.set('themeWebCountAfetrLogin',this.getThemeWebCount);
            Vue.prototype.$session.set('themeMagazineCountAfetrLogin',this.getThemeMagazineCount);
            this.defaultDateLoading = 1
            this.sendMailValue = 0
            this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
            
            var inputParam;
            var webinputParam;
            var magazineinputParam;
            var totalNewsLabel;
            var webNewsLabel;
            var magazineLabel;
            this.restrictArticleSortingDate = 1
            this.restrictDateFunction = 0

            if(this.themeValueDate == "Theme")
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_id:this.setMailThemeId
              }
              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_id:this.setMailThemeId
              }
              this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', this.setMailThemeId);
              this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);
              
            }
            else if(this.themeValueDate == "Theme Group")
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_group_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_group_id:this.setMailThemeId
              }
              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                theme_group_id:this.setMailThemeId
              }
              this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', this.setMailThemeId);
              this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);
              
            }
            else
            {
              inputParam ={
                contract_id: this.contractId,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date: this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                topics_id:this.setMailThemeId
              }
              
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                topics_id:this.setMailThemeId
              }
              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:this.getArticleDate,
                sort_title:this.getArticleTitle,
                Start_num:1,
                Load_num:this.getArticleSortCount,
                topics_id:this.setMailThemeId
              }
              this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
              this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', this.setMailThemeId);
              
            }

            if(this.getThemeNewsCount != 0)
            {
              // this.loading = true
              console.log(inputParam)
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
              //Api call for get the news article
              this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
                }
                else
                {
                  this.newsCount = "新聞 (未登録)"
                  // this.newsSecondTabCount = "新聞 (未登録)"
                }
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
                this.load();
              }).catch(()=>{
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
                }
                else
                {
                  this.newsCount = "新聞 (未登録)"
                  // this.newsSecondTabCount = "新聞 (未登録)"
                }
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
                this.load();
              })
            }
            else
            {
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)"
              }
              else
              {
                this.newsCount = "新聞 (未登録)"
                // this.newsSecondTabCount = "新聞 (未登録)"
              }
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
              this.$store.commit('sp_Situation0001/setTotalNewsLabel', totalNewsLabel, { root: true });
              this.load();
            }

            if(this.getThemeWebCount != 0)
            {
              console.log(webinputParam)
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
              //Api call to get web article
              this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', true);
                if(this.getWebRegisterFlag)
                {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
                }
                else
                {
                  this.webCount = "WEB (未登録)"
                }
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
                this.webLoad();
              }).catch(()=>{
                this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
                if(this.getWebRegisterFlag)
                {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
                }
                else
                {
                  this.webCount = "WEB (未登録)"
                }
                this.webLoad();
              })
            }
            else
            {
              this.$store.commit('sp_Situation0001/setIsTopPageInitialLoading', false);
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)"
              }
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('sp_Situation0001/setWebTotalLabel', webNewsLabel, { root: true });
              this.webLoad();
            }

            if(this.getThemeMagazineCount != 0)
            {
              this.fullscreenLoading = true;
              //Api call to get web article
              this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
                this.fullscreenLoading = false;
                if(this.getMagazineRegisterFlag)
                {
                  this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                }
                else
                {
                  this.magazineCount = "雑誌 (未登録)";
                }
                magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                this.magazineLoad();
              }).catch(() => {
                this.fullscreenLoading = false;
                if(this.getMagazineRegisterFlag)
                {
                  this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                }
                else
                {
                  this.magazineCount = "雑誌 (未登録)";
                }
                magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
                this.magazineLoad();
                this.fullscreenLoading = false;
              })
            }
            else
            {
              if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              magazineLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('sp_Situation0001/setMagazineTotalLabel', magazineLabel);
              this.magazineLoad();
            }

          })
        })
      }
      else if(this.getThemeLoadCheck == 1)
      {
        this.$store.commit("sp_Situation0001/setThemeNewsCount", Vue.prototype.$session.get('themeNewsCountForMobileSorting'));
        this.$store.commit('sp_Situation0001/setThemeWebCount', Vue.prototype.$session.get('themeWebNewsCountForMobileSorting'));
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', Vue.prototype.$session.get('themeMagazineCountForMobileSorting'));
        this.setMailThemeValue = this.getDefaultMailTheme;
        this.setMailThemeId = this.getSelectedTheme[0].id;
        this.themeValueDate = this.getSelectedTheme[0].value;
        this.selected_theme_name = this.getSelectedLabel;
        this.defaultDateLoading = 1;
        this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
        this.restrictArticleSortingDate = 0;
        this.restrictDateFunction = 1;

        console.log(this.getThemeNewsCount);
        console.log(this.getThemeWebCount);
        
        console.log(this.getTodayArticleFlag)
        console.log(this.getSearchConditionKey)
        var inputParam;
        var webinputParam;
        var magazineinputParam;
        if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
        {
          this.sendMailValue = 0;
          console.log(this.restrictArticleSortingDate)
          this.range = {
            start: new Date(this.getSearchStartDate),
            end: new Date(this.getSearchEndDate)
          }

          this.AllTabs = this.getTabCheckFlagForSorting;

          if(this.AllTabs == "first")
          {
            if(this.getNewswebCheck == 2)
            {
              this.activeTab = "2";
            }
            if(this.getNewswebCheck == 5)
            {
              this.activeTab = "5";
            }
          }

          if(this.themeValueDate == "Theme")
          {
            inputParam ={
              contract_id: this.contractId,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date: this.getArticleDate,
              sort_title:this.getArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              theme_id:this.setMailThemeId
            }
            
            //parameter for api AID0005
            webinputParam ={
              contract_id: this.contractId,
              data_section: 3,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date:this.getWebArticleDate,
              sort_title:this.getWebArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              theme_id:this.setMailThemeId
            }
            magazineinputParam ={
              contract_id: this.contractId,
              data_section: 5,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date:this.getMagazineArticleDate,
              sort_title:this.getMagazineArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              theme_id:this.setMailThemeId
            }
          }
          else if(this.themeValueDate == "Theme Group")
          {
            inputParam ={
              contract_id: this.contractId,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date: this.getArticleDate,
              sort_title:this.getArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              theme_group_id:this.setMailThemeId
            }
            
            //parameter for api AID0005
            webinputParam ={
              contract_id: this.contractId,
              data_section: 3,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date:this.getWebArticleDate,
              sort_title:this.getWebArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              theme_group_id:this.setMailThemeId
            }
            magazineinputParam ={
              contract_id: this.contractId,
              data_section: 5,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date:this.getMagazineArticleDate,
              sort_title:this.getMagazineArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              theme_group_id:this.setMailThemeId
            }
          }
          else
          {
            inputParam ={
              contract_id: this.contractId,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date: this.getArticleDate,
              sort_title:this.getArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              topics_id:this.setMailThemeId
            }
            
            //parameter for api AID0005
            webinputParam ={
              contract_id: this.contractId,
              data_section: 3,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date:this.getWebArticleDate,
              sort_title:this.getWebArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              topics_id:this.setMailThemeId
            }
            magazineinputParam ={
              contract_id: this.contractId,
              data_section: 5,
              process_date_start:this.getSearchStartDate,
              process_date_end:this.getSearchEndDate,
              sort_date:this.getMagazineArticleDate,
              sort_title:this.getMagazineArticleTitle,
              Start_num:1,
              Load_num:this.getArticleSortCount,
              topics_id:this.setMailThemeId
            }
          }

          if(this.getNewswebCheck == 1)
          {
            console.log("sorting Web News check");
            // if(this.getThemeNewsCount != 0)
            // {
              this.fullscreenLoading = true;
              //Api call for get the news article
              this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                this.defaultDateLoading = 1
                this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                }
                else
                {
                  this.newsCount = "新聞 (未登録)";
                  // this.newsSecondTabCount = "新聞 (未登録)";
                }
                if(this.getWebRegisterFlag)
                {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
                }
                else
                {
                  this.webCount = "WEB (未登録)";
                }
                if(this.getMagazineRegisterFlag)
                {
                  this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                }
                else
                {
                  this.magazineCount = "雑誌 (未登録)";
                }
                this.fullscreenLoading = false;
                this.load();
                this.magazineLoad();
                this.webLoad();
                this.restrictArticleSortingDate = 1;
              })
            // }
            // else
            // {
            //   if(this.getScRegisterFlag)
            //   {
            //     this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            //     this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            //   }
            //   else
            //   {
            //     this.newsCount = "新聞 (未登録)";
            //     this.newsSecondTabCount = "新聞 (未登録)";
            //   }
            //   this.load();
            //   // this.restrictArticleSortingDate = 1;
            // }
          }
          else if(this.getNewswebCheck == 2)
          {
            console.log("sorting Web News check");
            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
              this.defaultDateLoading = 1
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              this.fullscreenLoading = false;
              this.webLoad();
              this.magazineLoad();
              this.load();
              this.restrictArticleSortingDate = 1;
            })
          }
          else if(this.getNewswebCheck == 5)
          {
            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
              this.defaultDateLoading = 1
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              this.fullscreenLoading = false;
              this.magazineLoad();
              this.load();
              this.webLoad();
              this.restrictArticleSortingDate = 1;
            })
          }
          else
          {

            this.fullscreenLoading = true;
            //Api call for get the news article
            this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
              this.defaultDateLoading = 1;
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              this.fullscreenLoading = false;
              this.load();
              this.restrictArticleSortingDate = 1;
            })

            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
              this.defaultDateLoading = 1;
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              this.fullscreenLoading = false;
              this.webLoad();
              this.restrictArticleSortingDate = 1;
            })

            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
              this.defaultDateLoading = 1;
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              this.fullscreenLoading = false;
              this.magazineLoad();
              this.restrictArticleSortingDate = 1;
            })
          }

          this.restrictDateFunction = 0;
          this.startDateResult = this.getSearchStartDate;
          this.endDateResult = this.getSearchEndDate;
        }
        else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
        {
          this.sendMailValue = 1;
          this.range = {
            start: new Date(this.getSearchStartDate),
            end: new Date(this.getSearchEndDate)
          }

          this.AllTabs = this.getTabCheckFlagForSorting;

          if(this.AllTabs == "first")
          {
            if(this.getNewswebCheck == 2)
            {
              this.activeTab = "2";
            }
            if(this.getNewswebCheck == 5)
            {
              this.activeTab = "5";
            }
          }

          inputParam ={
            contract_id: this.contractId,
            process_date_start:this.getSearchStartDate,
            process_date_end:this.getSearchEndDate,
            sort_date: this.getArticleDate,
            sort_title:this.getArticleTitle,
            Start_num:1,
            Load_num:this.getArticleSortCount
          }
          
          //parameter for api AID0005
          webinputParam ={
            contract_id: this.contractId,
            data_section: 3,
            process_date_start:this.getSearchStartDate,
            process_date_end:this.getSearchEndDate,
            sort_date:this.getWebArticleDate,
            sort_title:this.getWebArticleTitle,
            Start_num:1,
            Load_num:this.getArticleSortCount
          }
          magazineinputParam ={
            contract_id: this.contractId,
            data_section: 5,
            process_date_start:this.getSearchStartDate,
            process_date_end:this.getSearchEndDate,
            sort_date:this.getMagazineArticleDate,
            sort_title:this.getMagazineArticleTitle,
            Start_num:1,
            Load_num:this.getArticleSortCount
          }
        
          console.log(this.restrictArticleSortingDate)
          console.log(this.getNewswebCheck)
          if(this.getNewswebCheck == 1)
          {
            console.log("sorting news Check");
            // if(this.getThemeNewsCount != 0)
            // {
              this.fullscreenLoading = true;
              //Api call for get the news article
              this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
                this.defaultDateLoading = 1
                this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
                if(this.getMagazineRegisterFlag)
                {
                  this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
                }
              else
                {
                  this.magazineCount = "雑誌 (未登録)";
                }
                if(this.getWebRegisterFlag)
                {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
                }
                else
                {
                  this.webCount = "WEB (未登録)";
                }
                if(this.getScRegisterFlag)
                {
                  this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                  // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                }
                else
                {
                  this.newsCount = "新聞 (未登録)";
                  // this.newsSecondTabCount = "新聞 (未登録)";
                }
                this.fullscreenLoading = false;
                this.load();
                this.magazineLoad();
                this.webLoad();
                this.restrictArticleSortingDate = 1;
              })
            // }
            // else
            // {
            //   if(this.getScRegisterFlag)
            //   {
            //     this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            //     this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
            //   }
            //   else
            //   {
            //     this.newsCount = "新聞 (未登録)";
            //     this.newsSecondTabCount = "新聞 (未登録)";
            //   }
            //   this.load();
            //   this.restrictArticleSortingDate = 1;
            // }

            // if(this.getWebRegisterFlag)
            // {
            //   this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
            // }
            // else
            // {
            // }

            
          }
          else if(this.getNewswebCheck == 2)
          {
            console.log("sorting webNews Check");
            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
              this.defaultDateLoading = 1
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              this.fullscreenLoading = false;
              this.webLoad();
              this.magazineLoad();
              this.load();
              this.restrictArticleSortingDate = 1;
            })
          }
          else if(this.getNewswebCheck == 5)
          {
            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
              this.defaultDateLoading = 1
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              if(this.getWebRegisterFlag)
              {
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              this.fullscreenLoading = false;
              this.magazineLoad();
              this.webLoad();
              this.load();
              this.restrictArticleSortingDate = 1;
            })
          }
          else
          {

            this.fullscreenLoading = true;
            //Api call for get the news article
            this.$store.dispatch('sp_Communication0001/getNewspaperArticles', inputParam).then(() => {
              this.defaultDateLoading = 1;
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getScRegisterFlag)
              {
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getThemeNewsCount + "件)";
              }
              else
              {
                this.newsCount = "新聞 (未登録)";
                // this.newsSecondTabCount = "新聞 (未登録)";
              }
              this.fullscreenLoading = false;
              this.load();
              this.restrictArticleSortingDate = 1;
            })

            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getWebArticles', webinputParam).then(() => {
              this.defaultDateLoading = 1;
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getWebRegisterFlag)
              {
                  // 2021/07/07  #11597  START
                  //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getThemeWebCount + "件)";
                  this.webCount = "WEB (0/" + this.getThemeWebCount + "件)";
                  // 2021/07/07  #11597  END
              }
              else
              {
                this.webCount = "WEB (未登録)";
              }
              this.fullscreenLoading = false;
              this.webLoad();
              this.restrictArticleSortingDate = 1;
            })

            this.fullscreenLoading = true;
            //Api call to get web article
            this.$store.dispatch('sp_Communication0001/getMagazineArticles', magazineinputParam).then(() => {
              this.defaultDateLoading = 1;
              this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', this.defaultDateLoading);
              if(this.getMagazineRegisterFlag)
              {
                this.magazineCount = "雑誌 (0"  + "/" + this.getThemeMagazineCount + "件)";
              }
              else
              {
                this.magazineCount = "雑誌 (未登録)";
              }
              this.fullscreenLoading = false;
              this.magazineLoad();
              this.restrictArticleSortingDate = 1;
            })
            
          }

          this.restrictDateFunction = 0;
          this.startDateResult = this.getSearchStartDate;
          this.endDateResult = this.getSearchEndDate;
        }
        else if(this.getSearchConditionKey == 1)
        {
          this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);
          this.sendMailValue = 1;
          this.range = {
            start: new Date(this.getSearchStartDate),
            end: new Date(this.getSearchEndDate)
          }
          this.setMailThemeId = Vue.prototype.$session.get('themeIdAfterLogin');
          this.themeValueDate = Vue.prototype.$session.get('themeValueAfterLogin');

          this.$store.commit('sp_Situation0001/setScRegisterFlag', true);
          this.$store.commit('sp_Situation0001/setWebregisterFlag', true);
          this.$store.commit('sp_Situation0001/setMagazineregisterFlag', true);
          this.$store.commit('sp_Situation0001/setThemeIdForPdfSuccess', null);
          this.$store.commit('sp_Situation0001/setThemeGroupIdForPdfSuccess', null);
          this.$store.commit('sp_Situation0001/setTopicsIdForPdfSuccess', null);

          var article_search_condition;

          if(this.getNewswebCheck == 1)
          {

            if(this.getSearchValue != '')//if value is selected from search dropdown
            {
              article_search_condition = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 1,
                display_id: 'SID0002',
                process_date_from: this.getSearchStartDate,
                process_date_to: this.getSearchEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getArticleDate,
                search_title: this.getSearchValue,
                start_num: 1,
                load_num: 10,
                sort_title: this.getArticleTitle
                  
              }
            }
            else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getArticleDate,
                  start_num: 1,
                  load_num: 10,
                  sort_title: this.getArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  user_id: this.userId,
                  key_word: this.getKeywordValue,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else//if keyword textbox is equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getArticleDate,
                  start_num: 1,
                  load_num: 10,
                  sort_title: this.getArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 1,
                  display_id: "SID0002",
                  user_id: this.userId,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: this.getArticleDate,
                  sort_title: this.getArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }

            this.fullscreenLoading = true;
            //Api call for search the article by using keyword, media and search dropdown value
            this.$store.dispatch('sp_Communication0001/getNewsArticleUsingSorting', article_search_condition).then(() => {
              this.restrictDateFunction = 0;
              this.restrictArticleSortingDate = 1;
              this.flagForSetDefaultCount = 1;
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getWebTotalNewsCount + "件)";
              this.webCount = "WEB (0/" + this.getWebTotalNewsCount + "件)";
              // 2021/07/07  #11597  END
              this.magazineCount = "雑誌 (0" + "/" + this.getMagazineTotalNewsCount + "件)";
              this.selected_theme_name = "検索結果" + "(" + parseInt(this.getTotalNewsCount + this.getWebTotalNewsCount + this.getMagazineTotalNewsCount) + "件)";
              this.fullscreenLoading = false;
              this.load();
            })
          }
          else if(this.getNewswebCheck == 2)
          {

            if(this.getSearchValue != '')//if value is selected from search dropdown
            {
              article_search_condition = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 2,
                display_id: 'SID0002',
                process_date_from: this.getSearchStartDate,
                process_date_to: this.getSearchEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getWebArticleDate,
                search_title: this.getSearchValue,
                start_num: 1,
                load_num: 10,
                sort_title: this.getWebArticleTitle
                  
              }
            }
            else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getWebArticleDate,
                  start_num: 1,
                  load_num: 10,
                  sort_title: this.getWebArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 2,
                  display_id: "SID0002",
                  user_id: this.userId,
                  key_word: this.getKeywordValue,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: this.getWebArticleDate,
                  sort_title: this.getWebArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else//if keyword textbox is equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getWebArticleDate,
                  start_num: 1,
                  load_num: 10,
                  sort_title: this.getWebArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 2,
                  display_id: "SID0002",
                  user_id: this.userId,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: this.getWebArticleDate,
                  sort_title: this.getWebArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }

            this.fullscreenLoading = true;
            //Api call for search the article by using keyword, media and search dropdown value
            this.$store.dispatch('sp_Communication0001/getWebArticleUsingSorting', article_search_condition).then(() => {
              this.restrictDateFunction = 0;
              this.restrictArticleSortingDate = 1;
              this.flagForSetDefaultCount = 1;
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getWebTotalNewsCount + "件)";
              this.webCount = "WEB (0/" + this.getWebTotalNewsCount + "件)";
              // 2021/07/07  #11597  END
              this.magazineCount = "雑誌 (0" + "/" + this.getMagazineTotalNewsCount + "件)";
              this.selected_theme_name = "検索結果" + "(" + parseInt(this.getTotalNewsCount + this.getWebTotalNewsCount + this.getMagazineTotalNewsCount) + "件)";
              this.fullscreenLoading = false;
              this.webLoad();
            })
          }
          else if(this.getNewswebCheck == 5)
          {

            if(this.getSearchValue != '')//if value is selected from search dropdown
            {
              article_search_condition = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 5,
                display_id: 'SID0002',
                process_date_from: this.getSearchStartDate,
                process_date_to: this.getSearchEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getMagazineArticleDate,
                search_title: this.getSearchValue,
                start_num: 1,
                load_num: 10,
                sort_title: this.getMagazineArticleTitle

              }
            }
            else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 5,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getMagazineArticleDate,
                  start_num: 1,
                  load_num: 10,
                  sort_title: this.getMagazineArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 5,
                  display_id: "SID0002",
                  user_id: this.userId,
                  key_word: this.getKeywordValue,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: this.getMagazineArticleDate,
                  sort_title: this.getMagazineArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else//if keyword textbox is equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 5,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getMagazineArticleDate,
                  start_num: 1,
                  load_num: 10,
                  sort_title: this.getMagazineArticleTitle
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 5,
                  display_id: "SID0002",
                  user_id: this.userId,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: this.getMagazineArticleDate,
                  sort_title: this.getMagazineArticleTitle,
                  theme_browsing: this.theme_browsing
                }
              }
            }

            this.fullscreenLoading = true;
            //Api call for search the article by using keyword, media and search dropdown value
            this.$store.dispatch('sp_Communication0001/getMagazineArticleUsingSorting', article_search_condition).then(() => {
              this.restrictDateFunction = 0;
              this.restrictArticleSortingDate = 1;
              this.flagForSetDefaultCount = 1;
              this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
              // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
              // 2021/07/07  #11597  START
              //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getWebTotalNewsCount + "件)";
              this.webCount = "WEB (0/" + this.getWebTotalNewsCount + "件)";
              // 2021/07/07  #11597  END
              this.magazineCount = "雑誌 (0" + "/" + this.getMagazineTotalNewsCount + "件)";
              this.selected_theme_name = "検索結果" + "(" + parseInt(this.getTotalNewsCount + this.getWebTotalNewsCount + this.getMagazineTotalNewsCount) + "件)";
              this.fullscreenLoading = false;
              this.magazineLoad();
            })
          }
          else
          {

            if(this.getSearchValue != '')//if value is selected from search dropdown
            {
              article_search_condition = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 0,
                display_id: 'SID0002',
                process_date_from: this.getSearchStartDate,
                process_date_to: this.getSearchEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: '',
                search_title: this.getSearchValue,
                start_num: 1,
                load_num: 10,
                sort_title: ''
                  
              }
            }
            else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 0,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: '',
                  start_num: 1,
                  load_num: 10,
                  sort_title: ''
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 0,
                  display_id: "SID0002",
                  user_id: this.userId,
                  key_word: this.getKeywordValue,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: '',
                  sort_title: '',
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else//if keyword textbox is equal to empty
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 0,
                  display_id: "SID0002",
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: '',
                  start_num: 1,
                  load_num: 10,
                  sort_title: ''
                }
              }
              else//if media texbox is equal to empty
              {
                article_search_condition = {
                  contract_id: this.contractId,
                  contract_kbn: 0,
                  display_id: "SID0002",
                  user_id: this.userId,
                  process_date_from: this.getSearchStartDate,
                  process_date_to: this.getSearchEndDate,
                  start_num: 1,
                  load_num: 10,
                  sort_date: '',
                  sort_title: '',
                  theme_browsing: this.theme_browsing
                }
              }
            }

            var themeDetails = {
              contract_id: this.contractId,
              theme_browsing: this.theme_browsing,
              user_id: this.userId,
              display_id: "SID0002",
              process_date_start: this.getSearchStartDate,
              process_date_end: this.getSearchEndDate
            };

            var existingArticleDetails = [];

            existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId];

            this.fullscreenLoading = true;
            //Api call to get article theme values
            this.$store.dispatch('sp_Communication0001/getTheme', existingArticleDetails).then(() => {
              // this.fullscreenLoading = false;
              //Api call for search the article by using keyword, media and search dropdown value
              this.$store.dispatch('sp_Communication0001/getArticleUsingSearch', article_search_condition).then(() => {
                this.restrictDateFunction = 0;
                this.restrictArticleSortingDate = 1;
                this.flagForSetDefaultCount = 1;
                this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getTotalNewsCount);
                this.$store.commit('sp_Situation0001/setThemeWebCount', this.getWebTotalNewsCount);
                this.$store.commit('sp_Situation0001/setThemeMagazineCount', this.getMagazineTotalNewsCount);
                this.newsCount = "新聞 (" + this.getNewsFirstTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
                // this.newsSecondTabCount = "新聞 (" + this.getNewsSecondTabCheckboxValue + "/" + this.getTotalNewsCount + "件)";
                // 2021/07/07  #11597  START
                //this.webCount = "WEB (" + this.getNewsFirstTabCheckboxValue + "/" + this.getWebTotalNewsCount + "件)";
                this.webCount = "WEB (0/" + this.getWebTotalNewsCount + "件)";
                // 2021/07/07  #11597  END
                this.magazineCount = "雑誌 (0" + "/" + this.getMagazineTotalNewsCount + "件)";
                this.selected_theme_name = "検索結果" + "(" + parseInt(this.getTotalNewsCount + this.getWebTotalNewsCount + this.getMagazineTotalNewsCount) + "件)";
                this.fullscreenLoading = false;
                this.load();
                this.webLoad();
                this.magazineLoad();
              })
            })
          }

          this.restrictDateFunction = 0;
          this.startDateResult = this.getSearchStartDate;
          this.endDateResult = this.getSearchEndDate;
        }
      }
    })
  // 2021/07/07  #11597  START
  if(this.getNewsFirstTabCheckboxValue == 0)
  {
    this.checkedNewsArticle=[];
    defaultValue=[];
  }
  // 2021/07/07  #11597  END
  },
  
  beforeCreate(){
    //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
    //Common.Session.CheckIsMobile("/sp","/"); // MobileScreen Path, WebScreen Path
  }
};
</script>

<style scoped>
@import "0001.css";
@import "../../../assets/css/customStyle.css";
</style>
